export const GLOBAL_ICONS = {
  eyes: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 5.17857C4.64286 5.17857 2.5 10 2.5 10C2.5 10 4.64286 14.8214 10 14.8214C15.3571 14.8214 17.5 10 17.5 10C17.5 10 15.3571 5.17857 10 5.17857Z"
        stroke="#7E8299" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M10.0003 12.6786C11.4797 12.6786 12.6789 11.4794 12.6789 10C12.6789 8.52071 11.4797 7.32147 10.0003 7.32147C8.52101 7.32147 7.32178 8.52071 7.32178 10C7.32178 11.4794 8.52101 12.6786 10.0003 12.6786Z"
        stroke="#7E8299" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  caretUp: (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 4.75L5 1L8.75 4.75"
        stroke="#1E9A98"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevronDown: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.495 8.49497C14.7683 8.22161 14.7683 7.77839 14.495 7.50502C14.2216 7.23166 13.7784 7.23166 13.505 7.50502L14.495 8.49497ZM10 12L9.50503 12.495C9.77839 12.7683 10.2216 12.7683 10.495 12.495L10 12ZM6.49497 7.50502C6.22161 7.23166 5.77839 7.23166 5.50503 7.50502C5.23166 7.77839 5.23166 8.22161 5.50503 8.49497L6.49497 7.50502ZM13.505 7.50502L9.50503 11.505L10.495 12.495L14.495 8.49497L13.505 7.50502ZM10.495 11.505L6.49497 7.50502L5.50503 8.49497L9.50503 12.495L10.495 11.505Z"
        fill="white"
      />
    </svg>
  ),
  edit: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.25 3.00005H4.1C2.83988 3.00005 2.20982 3.00005 1.72852 3.24528C1.30516 3.461 0.96095 3.80521 0.745235 4.22857C0.5 4.70987 0.5 5.33993 0.5 6.60005V12.9C0.5 14.1602 0.5 14.7902 0.745235 15.2715C0.96095 15.6949 1.30516 16.0391 1.72852 16.2548C2.20982 16.5 2.83988 16.5 4.1 16.5H10.4C11.6601 16.5 12.2902 16.5 12.7715 16.2548C13.1948 16.0391 13.539 15.6949 13.7548 15.2715C14 14.7902 14 14.1602 14 12.9V9.75005M4.99998 12H6.25589C6.62277 12 6.80622 12 6.97885 11.9586C7.1319 11.9219 7.27822 11.8613 7.41243 11.779C7.5638 11.6862 7.69352 11.5565 7.95294 11.2971L15.125 4.12505C15.7463 3.50373 15.7463 2.49637 15.125 1.87505C14.5037 1.25373 13.4963 1.25373 12.875 1.87505L5.70293 9.0471C5.4435 9.30653 5.31378 9.43625 5.22102 9.58762C5.13878 9.72183 5.07817 9.86815 5.04143 10.0212C4.99998 10.1938 4.99998 10.3773 4.99998 10.7442V12Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  dismiss: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1L1 13M1 1L13 13" stroke="#F4F7FC" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  openLock: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 11.25C9.77665 11.25 10.4062 10.6204 10.4062 9.84375C10.4062 9.0671 9.77665 8.4375 9 8.4375C8.22335 8.4375 7.59375 9.0671 7.59375 9.84375C7.59375 10.6204 8.22335 11.25 9 11.25Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 11.25V12.9375" stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M14.625 6.1875H3.375C3.06434 6.1875 2.8125 6.43934 2.8125 6.75V14.625C2.8125 14.9357 3.06434 15.1875 3.375 15.1875H14.625C14.9357 15.1875 15.1875 14.9357 15.1875 14.625V6.75C15.1875 6.43934 14.9357 6.1875 14.625 6.1875Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M6.46875 6.1875V3.65625C6.46875 2.98492 6.73543 2.34109 7.21014 1.86639C7.68484 1.39168 8.32867 1.125 9 1.125C9.67133 1.125 10.3152 1.39168 10.7899 1.86639C11.2646 2.34109 11.5312 2.98492 11.5312 3.65625"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  closeLock: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 11.25C9.77665 11.25 10.4062 10.6204 10.4062 9.84375C10.4062 9.0671 9.77665 8.4375 9 8.4375C8.22335 8.4375 7.59375 9.0671 7.59375 9.84375C7.59375 10.6204 8.22335 11.25 9 11.25Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 11.25V12.9375" stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M14.625 6.1875H3.375C3.06434 6.1875 2.8125 6.43934 2.8125 6.75V14.625C2.8125 14.9357 3.06434 15.1875 3.375 15.1875H14.625C14.9357 15.1875 15.1875 14.9357 15.1875 14.625V6.75C15.1875 6.43934 14.9357 6.1875 14.625 6.1875Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M6.46875 6.1875V3.65625C6.46875 2.98492 6.73543 2.34109 7.21014 1.86639C7.68484 1.39168 8.32867 1.125 9 1.125C9.67133 1.125 10.3152 1.39168 10.7899 1.86639C11.2646 2.34109 11.5312 2.98492 11.5312 3.65625V6.1875"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  user: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 11.25C10.5533 11.25 11.8125 9.9908 11.8125 8.4375C11.8125 6.8842 10.5533 5.625 9 5.625C7.4467 5.625 6.1875 6.8842 6.1875 8.4375C6.1875 9.9908 7.4467 11.25 9 11.25Z"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M4.48633 14.0207C4.90955 13.1871 5.55533 12.487 6.3521 11.9979C7.14887 11.5089 8.0655 11.25 9.00039 11.25C9.93528 11.25 10.8519 11.5089 11.6487 11.9979C12.4455 12.487 13.0912 13.1871 13.5145 14.0207"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.0625 9L15.75 10.6875L17.4375 9" stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.5625 9L2.25 7.3125L3.9375 9" stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M15.7504 10.6871V8.99956C15.752 7.54118 15.2812 6.12152 14.4085 4.95306C13.5359 3.7846 12.3082 2.9302 10.9094 2.51776C9.51054 2.10531 8.01575 2.157 6.64874 2.66508C5.28174 3.17317 4.11605 4.11033 3.32617 5.33628"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M2.25 7.3125V9C2.24841 10.4584 2.71919 11.878 3.59186 13.0465C4.46454 14.215 5.69218 15.0694 7.09101 15.4818C8.48985 15.8942 9.98465 15.8426 11.3517 15.3345C12.7187 14.8264 13.8843 13.8892 14.6742 12.6633"
        stroke="#6E6D7A" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  question: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
            stroke="#808089" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M8 12.667C8.48325 12.667 8.875 12.2752 8.875 11.792C8.875 11.3087 8.48325 10.917 8 10.917C7.51675 10.917 7.125 11.3087 7.125 11.792C7.125 12.2752 7.51675 12.667 8 12.667Z"
        fill="#808089"/>
      <path
        d="M7.99967 9.16667V8.58333C8.40348 8.58333 8.79821 8.46359 9.13396 8.23925C9.46971 8.01491 9.7314 7.69605 9.88593 7.32298C10.0405 6.94991 10.0809 6.5394 10.0021 6.14336C9.92333 5.74731 9.72888 5.38352 9.44335 5.09799C9.15782 4.81246 8.79403 4.61801 8.39798 4.53923C8.00194 4.46045 7.59143 4.50088 7.21836 4.65541C6.8453 4.80994 6.52643 5.07163 6.30209 5.40738C6.07775 5.74313 5.95801 6.13786 5.95801 6.54167"
        stroke="#808089" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  calendar: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 9.03464C16.8866 9.03464 17.2 8.72124 17.2 8.33464C17.2 7.94804 16.8866 7.63464 16.5 7.63464V9.03464ZM1.5 7.63464C1.1134 7.63464 0.8 7.94804 0.8 8.33464C0.8 8.72124 1.1134 9.03464 1.5 9.03464V7.63464ZM2.86502 18.0622L2.54723 18.6859L2.86502 18.0622ZM1.77248 16.9696L1.14878 17.2874L1.77248 16.9696ZM16.2275 16.9696L16.8512 17.2874L16.2275 16.9696ZM15.135 18.0622L15.4528 18.6859L15.135 18.0622ZM15.135 3.60712L15.4528 2.98341V2.98341L15.135 3.60712ZM16.2275 4.69966L16.8512 4.38187L16.2275 4.69966ZM2.86502 3.60712L2.54723 2.98341V2.98341L2.86502 3.60712ZM1.77248 4.69966L1.14878 4.38187L1.77248 4.69966ZM13.0333 1.66797C13.0333 1.28137 12.7199 0.967969 12.3333 0.967969C11.9467 0.967969 11.6333 1.28137 11.6333 1.66797H13.0333ZM11.6333 5.0013C11.6333 5.3879 11.9467 5.7013 12.3333 5.7013C12.7199 5.7013 13.0333 5.3879 13.0333 5.0013H11.6333ZM6.36667 1.66797C6.36667 1.28137 6.05327 0.967969 5.66667 0.967969C5.28007 0.967969 4.96667 1.28137 4.96667 1.66797H6.36667ZM4.96667 5.0013C4.96667 5.3879 5.28007 5.7013 5.66667 5.7013C6.05327 5.7013 6.36667 5.3879 6.36667 5.0013H4.96667ZM16.5 7.63464H1.5V9.03464H16.5V7.63464ZM5.5 4.03464H12.5V2.63464H5.5V4.03464ZM15.8 7.33464V14.3346H17.2V7.33464H15.8ZM12.5 17.6346H5.5V19.0346H12.5V17.6346ZM2.2 14.3346V7.33464H0.8V14.3346H2.2ZM5.5 17.6346C4.78838 17.6346 4.29677 17.6341 3.91501 17.6029C3.54142 17.5724 3.33508 17.516 3.18282 17.4384L2.54723 18.6859C2.92975 18.8808 3.34083 18.9607 3.801 18.9983C4.253 19.0352 4.81148 19.0346 5.5 19.0346V17.6346ZM0.8 14.3346C0.8 15.0232 0.799456 15.5816 0.836385 16.0336C0.873983 16.4938 0.953877 16.9049 1.14878 17.2874L2.39619 16.6518C2.31861 16.4996 2.26226 16.2932 2.23174 15.9196C2.20054 15.5379 2.2 15.0463 2.2 14.3346H0.8ZM3.18282 17.4384C2.84413 17.2659 2.56876 16.9905 2.39619 16.6518L1.14878 17.2874C1.45557 17.8895 1.94511 18.3791 2.54723 18.6859L3.18282 17.4384ZM15.8 14.3346C15.8 15.0463 15.7995 15.5379 15.7683 15.9196C15.7377 16.2932 15.6814 16.4996 15.6038 16.6518L16.8512 17.2874C17.0461 16.9049 17.126 16.4938 17.1636 16.0336C17.2005 15.5816 17.2 15.0232 17.2 14.3346H15.8ZM12.5 19.0346C13.1885 19.0346 13.747 19.0352 14.199 18.9983C14.6592 18.9607 15.0703 18.8808 15.4528 18.6859L14.8172 17.4384C14.6649 17.516 14.4586 17.5724 14.085 17.6029C13.7032 17.6341 13.2116 17.6346 12.5 17.6346V19.0346ZM15.6038 16.6518C15.4312 16.9905 15.1559 17.2659 14.8172 17.4384L15.4528 18.6859C16.0549 18.3791 16.5444 17.8895 16.8512 17.2874L15.6038 16.6518ZM12.5 4.03464C13.2116 4.03464 13.7032 4.03518 14.085 4.06637C14.4586 4.09689 14.6649 4.15324 14.8172 4.23082L15.4528 2.98341C15.0703 2.78851 14.6592 2.70862 14.199 2.67102C13.747 2.63409 13.1885 2.63464 12.5 2.63464V4.03464ZM17.2 7.33464C17.2 6.64612 17.2005 6.08764 17.1636 5.63564C17.126 5.17547 17.0461 4.76438 16.8512 4.38187L15.6038 5.01745C15.6814 5.16971 15.7377 5.37605 15.7683 5.74964C15.7995 6.13141 15.8 6.62302 15.8 7.33464H17.2ZM14.8172 4.23082C15.1559 4.4034 15.4312 4.67876 15.6038 5.01745L16.8512 4.38187C16.5444 3.77975 16.0549 3.29021 15.4528 2.98341L14.8172 4.23082ZM5.5 2.63464C4.81149 2.63464 4.253 2.63409 3.801 2.67102C3.34083 2.70862 2.92975 2.78851 2.54723 2.98341L3.18282 4.23082C3.33508 4.15324 3.54142 4.09689 3.91501 4.06637C4.29677 4.03518 4.78838 4.03464 5.5 4.03464V2.63464ZM2.2 7.33464C2.2 6.62302 2.20054 6.13141 2.23174 5.74964C2.26226 5.37605 2.31861 5.16971 2.39619 5.01745L1.14878 4.38187C0.953877 4.76438 0.873983 5.17547 0.836385 5.63564C0.799456 6.08764 0.8 6.64612 0.8 7.33464H2.2ZM2.54723 2.98341C1.94511 3.29021 1.45557 3.77975 1.14878 4.38187L2.39619 5.01745C2.56876 4.67876 2.84413 4.4034 3.18282 4.23082L2.54723 2.98341ZM11.6333 1.66797V5.0013H13.0333V1.66797H11.6333ZM4.96667 1.66797V5.0013H6.36667V1.66797H4.96667Z"
        fill="#3264FF"/>
    </svg>
  ),
  save: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3823_241651)">
        <path
          d="M5.33398 5.33331V3.46665C5.33398 2.71991 5.33398 2.34654 5.47931 2.06133C5.60714 1.81044 5.81111 1.60647 6.062 1.47864C6.34721 1.33331 6.72058 1.33331 7.46732 1.33331H12.534C13.2807 1.33331 13.6541 1.33331 13.9393 1.47864C14.1902 1.60647 14.3942 1.81044 14.522 2.06133C14.6673 2.34654 14.6673 2.71991 14.6673 3.46665V8.53331C14.6673 9.28005 14.6673 9.65342 14.522 9.93863C14.3942 10.1895 14.1902 10.3935 13.9393 10.5213C13.6541 10.6666 13.2807 10.6666 12.534 10.6666H10.6673M3.46732 14.6666H8.53398C9.28072 14.6666 9.65409 14.6666 9.93931 14.5213C10.1902 14.3935 10.3942 14.1895 10.522 13.9386C10.6673 13.6534 10.6673 13.28 10.6673 12.5333V7.46665C10.6673 6.71991 10.6673 6.34654 10.522 6.06133C10.3942 5.81044 10.1902 5.60647 9.93931 5.47864C9.65409 5.33331 9.28072 5.33331 8.53398 5.33331H3.46732C2.72058 5.33331 2.34721 5.33331 2.062 5.47864C1.81111 5.60647 1.60714 5.81044 1.47931 6.06133C1.33398 6.34654 1.33398 6.71991 1.33398 7.46665V12.5333C1.33398 13.28 1.33398 13.6534 1.47931 13.9386C1.60714 14.1895 1.81111 14.3935 2.062 14.5213C2.34721 14.6666 2.72058 14.6666 3.46732 14.6666Z"
          stroke="#7C88A6" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_3823_241651">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  ),

  delete: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7266 3.77734L7.99992 7.50401L4.27325 3.77734L3.33325 4.71734L7.05992 8.44401L3.33325 12.1707L4.27325 13.1107L7.99992 9.38401L11.7266 13.1107L12.6666 12.1707L8.93992 8.44401L12.6666 4.71734L11.7266 3.77734Z"
        fill="#7D9AC0"
      />
    </svg>
  ),
  download: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 8.33333L10 12.5M10 12.5L5.83333 8.33333M10 12.5V2.5"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  edit05: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 3.00017H5.1C3.83988 3.00017 3.20982 3.00017 2.72852 3.24541C2.30516 3.46112 1.96095 3.80533 1.74524 4.22869C1.5 4.70999 1.5 5.34005 1.5 6.60017V12.9002C1.5 14.1603 1.5 14.7903 1.74524 15.2716C1.96095 15.695 2.30516 16.0392 2.72852 16.2549C3.20982 16.5002 3.83988 16.5002 5.1 16.5002H11.4C12.6601 16.5002 13.2902 16.5002 13.7715 16.2549C14.1948 16.0392 14.539 15.695 14.7548 15.2716C15 14.7903 15 14.1603 15 12.9002V9.75017M5.99998 12.0002H7.25589C7.62277 12.0002 7.80622 12.0002 7.97885 11.9587C8.1319 11.922 8.27822 11.8614 8.41243 11.7791C8.5638 11.6864 8.69352 11.5567 8.95294 11.2972L16.125 4.12517C16.7463 3.50385 16.7463 2.49649 16.125 1.87517C15.5037 1.25385 14.4963 1.25385 13.875 1.87517L6.70293 9.04723C6.4435 9.30665 6.31378 9.43637 6.22102 9.58774C6.13878 9.72195 6.07817 9.86827 6.04143 10.0213C5.99998 10.194 5.99998 10.3774 5.99998 10.7443V12.0002Z"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  excel: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1293 3.70713H13.8936V2L2 3.83801V19.9489L13.8936 22V19.4697H21.1293C21.3484 19.4808 21.563 19.4046 21.7262 19.2577C21.8894 19.1108 21.9878 18.9052 22 18.6859V4.49026C21.9876 4.27103 21.8891 4.06561 21.726 3.91887C21.5628 3.77214 21.3483 3.69601 21.1293 3.70713ZM21.2436 18.816H13.8693L13.8571 17.465H15.6336V15.8917H13.8436L13.835 14.9619H15.6336V13.3885H13.8214L13.8129 12.4588H15.6336V10.8854H13.8071V9.95566H15.6336V8.38226H13.8071V7.45253H15.6336V5.87913H13.8071V4.44878H21.2436V18.816Z"
        fill="#7C88A6"
      />
      <path
        d="M16.6357 5.87207H19.7236V7.4435H16.6357V5.87207Z"
        fill="#7C88A6"
      />
      <path
        d="M16.6357 8.37305H19.7236V9.94448H16.6357V8.37305Z"
        fill="#7C88A6"
      />
      <path
        d="M16.6357 10.873H19.7236V12.4445H16.6357V10.873Z"
        fill="#7C88A6"
      />
      <path
        d="M16.6357 13.375H19.7236V14.9464H16.6357V13.375Z"
        fill="#7C88A6"
      />
      <path
        d="M16.6357 15.876H19.7236V17.4474H16.6357V15.876Z"
        fill="#7C88A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10701 8.18148L6.63987 8.09363L7.60344 10.7429L8.74202 7.98434L10.2749 7.89648L8.41344 11.6579L10.2749 15.4286L8.65416 15.3193L7.55987 12.4451L6.46487 15.2101L4.97559 15.0786L6.70559 11.7479L5.10701 8.18148Z"
        fill="white"
      />
    </svg>
  ),
  upload: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  uploadBanner: (
    <svg
      width="44"
      height="57"
      viewBox="0 0 44 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.5169 56.4441H1.48315C0.642697 56.4441 0 55.8004 0 54.9587V1.48537C0 0.64366 0.642697 0 1.48315 0H30.5034C30.9483 0 31.3438 0.198049 31.591 0.495123L43.6045 14.012C43.8517 14.2596 44 14.6557 44 15.0022V54.9587C44 55.7509 43.3573 56.4441 42.5169 56.4441Z"
        fill="#E6F9F7"
      />
      <path
        d="M43.9987 14.3586H33.765C32.0347 14.3586 30.6504 12.9722 30.6504 11.2393L31.1448 0L43.9987 14.3586Z"
        fill="#3264FF"
      />
      <path
        d="M21.3422 19.8867C16.146 19.8867 11.949 24.09 11.949 29.2941C11.949 34.4981 16.146 38.7014 21.3422 38.7014C26.5385 38.7014 30.7355 34.4581 30.7355 29.2941C30.7355 24.13 26.5385 19.8867 21.3422 19.8867ZM25.0196 28.2532C24.8597 28.4134 24.6599 28.4934 24.46 28.4934C24.2601 28.4934 24.0603 28.4134 23.9004 28.2532L22.1017 26.4518V33.9777C22.1017 34.4181 21.7419 34.7783 21.3023 34.7783C20.8626 34.7783 20.5028 34.4181 20.5028 33.9777V26.4919L18.7041 28.2933C18.3844 28.6135 17.9047 28.6135 17.5849 28.2933C17.2652 27.973 17.2652 27.4927 17.5849 27.1724L20.7027 24.05C20.7826 23.9699 20.8626 23.9299 20.9425 23.8898C21.1424 23.8098 21.3422 23.8098 21.5421 23.8898C21.622 23.9299 21.7419 23.9699 21.7819 24.05L24.8997 27.1724C25.3394 27.4526 25.3394 27.973 25.0196 28.2532Z"
        fill="#3264FF"
      />
      <path
        d="M26.2011 7.42578H6.42578V8.41603H26.2011V7.42578Z"
        fill="#3264FF"
      />
      <path
        d="M15.3247 11.3887H6.42578V12.3789H15.3247V11.3887Z"
        fill="#3264FF"
      />
      <path
        d="M15.3247 46.542H6.42578V47.5322H15.3247V46.542Z"
        fill="#3264FF"
      />
      <path
        d="M19.2803 46.542H17.3027V47.5322H19.2803V46.542Z"
        fill="#D5E3F2"
      />
    </svg>
  ),
  reload: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58333 17.417C13.4954 17.417 16.6667 14.2457 16.6667 10.3337C16.6667 7.97904 15.5178 5.89277 13.75 4.60482M10.4167 19.0003L8.75 17.3337L10.4167 15.667M9.58333 3.25033C5.67132 3.25033 2.5 6.42164 2.5 10.3337C2.5 12.6883 3.64889 14.7746 5.41667 16.0625M8.75 5.00033L10.4167 3.33366L8.75 1.66699"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4V16M4 10H16"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  locate: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0013 5.66699C6.71497 5.66699 5.66797 6.71366 5.66797 8.00033C5.66797 9.28699 6.71497 10.3337 8.0013 10.3337C9.28764 10.3337 10.3346 9.28699 10.3346 8.00033C10.3346 6.71366 9.28764 5.66699 8.0013 5.66699ZM8.0013 9.00033C7.44997 9.00033 7.0013 8.55166 7.0013 8.00033C7.0013 7.44899 7.44997 7.00033 8.0013 7.00033C8.55264 7.00033 9.0013 7.44899 9.0013 8.00033C9.0013 8.55166 8.55264 9.00033 8.0013 9.00033Z"
        fill="#191D32"
      />
      <path
        d="M8.0013 5.66699C6.71497 5.66699 5.66797 6.71366 5.66797 8.00033C5.66797 9.28699 6.71497 10.3337 8.0013 10.3337C9.28764 10.3337 10.3346 9.28699 10.3346 8.00033C10.3346 6.71366 9.28764 5.66699 8.0013 5.66699ZM8.0013 9.00033C7.44997 9.00033 7.0013 8.55166 7.0013 8.00033C7.0013 7.44899 7.44997 7.00033 8.0013 7.00033C8.55264 7.00033 9.0013 7.44899 9.0013 8.00033C9.0013 8.55166 8.55264 9.00033 8.0013 9.00033Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
      <path
        d="M15.3333 7.33333H13.9607C13.652 4.557 11.443 2.348 8.66667 2.03933V0.666667C8.66667 0.298667 8.368 0 8 0C7.632 0 7.33333 0.298667 7.33333 0.666667V2.03933C4.557 2.348 2.348 4.557 2.03933 7.33333H0.666667C0.298667 7.33333 0 7.632 0 8C0 8.368 0.298667 8.66667 0.666667 8.66667H2.03933C2.348 11.443 4.557 13.652 7.33333 13.9607V15.3333C7.33333 15.7013 7.632 16 8 16C8.368 16 8.66667 15.7013 8.66667 15.3333V13.9607C11.443 13.652 13.652 11.443 13.9607 8.66667H15.3333C15.7013 8.66667 16 8.368 16 8C16 7.632 15.7013 7.33333 15.3333 7.33333ZM8 12.6667C5.42667 12.6667 3.33333 10.5733 3.33333 8C3.33333 5.42667 5.42667 3.33333 8 3.33333C10.5733 3.33333 12.6667 5.42667 12.6667 8C12.6667 10.5733 10.5733 12.6667 8 12.6667Z"
        fill="#191D32"
      />
      <path
        d="M15.3333 7.33333H13.9607C13.652 4.557 11.443 2.348 8.66667 2.03933V0.666667C8.66667 0.298667 8.368 0 8 0C7.632 0 7.33333 0.298667 7.33333 0.666667V2.03933C4.557 2.348 2.348 4.557 2.03933 7.33333H0.666667C0.298667 7.33333 0 7.632 0 8C0 8.368 0.298667 8.66667 0.666667 8.66667H2.03933C2.348 11.443 4.557 13.652 7.33333 13.9607V15.3333C7.33333 15.7013 7.632 16 8 16C8.368 16 8.66667 15.7013 8.66667 15.3333V13.9607C11.443 13.652 13.652 11.443 13.9607 8.66667H15.3333C15.7013 8.66667 16 8.368 16 8C16 7.632 15.7013 7.33333 15.3333 7.33333ZM8 12.6667C5.42667 12.6667 3.33333 10.5733 3.33333 8C3.33333 5.42667 5.42667 3.33333 8 3.33333C10.5733 3.33333 12.6667 5.42667 12.6667 8C12.6667 10.5733 10.5733 12.6667 8 12.6667Z"
        fill="#F4F7FC"
        fillOpacity="0.8"
      />
    </svg>
  ),
  plus_circle: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M6.875 10H13.125"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.875V13.125"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  manipulation: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1998 4.8C10.1998 5.79411 11.0057 6.6 11.9998 6.6C12.9939 6.6 13.7998 5.79411 13.7998 4.8C13.7998 3.80589 12.9939 3 11.9998 3C11.0057 3 10.1998 3.80589 10.1998 4.8Z"
        fill="#7C88A6"
      />
      <path
        d="M10.1998 12.0002C10.1998 12.9943 11.0057 13.8002 11.9998 13.8002C12.9939 13.8002 13.7998 12.9943 13.7998 12.0002C13.7998 11.0061 12.9939 10.2002 11.9998 10.2002C11.0057 10.2002 10.1998 11.0061 10.1998 12.0002Z"
        fill="#7C88A6"
      />
      <path
        d="M10.1998 19.1999C10.1998 20.194 11.0057 20.9999 11.9998 20.9999C12.9939 20.9999 13.7998 20.194 13.7998 19.1999C13.7998 18.2058 12.9939 17.3999 11.9998 17.3999C11.0057 17.3999 10.1998 18.2058 10.1998 19.1999Z"
        fill="#7C88A6"
      />
    </svg>
  ),

  manipulation_hover: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2008 4.8C10.2008 5.79411 11.0067 6.6 12.0008 6.6C12.9949 6.6 13.8008 5.79411 13.8008 4.8C13.8008 3.80589 12.9949 3 12.0008 3C11.0067 3 10.2008 3.80589 10.2008 4.8Z"
        fill="#3264FF"
      />
      <path
        d="M10.2008 11.9992C10.2008 12.9933 11.0067 13.7992 12.0008 13.7992C12.9949 13.7992 13.8008 12.9933 13.8008 11.9992C13.8008 11.0051 12.9949 10.1992 12.0008 10.1992C11.0067 10.1992 10.2008 11.0051 10.2008 11.9992Z"
        fill="#3264FF"
      />
      <path
        d="M10.2008 19.2004C10.2008 20.1945 11.0067 21.0004 12.0008 21.0004C12.9949 21.0004 13.8008 20.1945 13.8008 19.2004C13.8008 18.2063 12.9949 17.4004 12.0008 17.4004C11.0067 17.4004 10.2008 18.2063 10.2008 19.2004Z"
        fill="#3264FF"
      />
    </svg>
  ),

  alertTriangle: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.79508 13.5739L7.96375 2.91897C8.30467 2.33009 8.47514 2.03566 8.69753 1.93677C8.89153 1.85051 9.11299 1.85051 9.30698 1.93677C9.52938 2.03566 9.69984 2.33009 10.0408 2.91896L16.2094 13.5739C16.5516 14.1649 16.7227 14.4604 16.6974 14.7029C16.6753 14.9145 16.5645 15.1067 16.3925 15.2318C16.1953 15.3752 15.8538 15.3752 15.1709 15.3752H2.83359C2.1507 15.3752 1.80925 15.3752 1.61204 15.2318C1.44002 15.1067 1.32919 14.9145 1.30714 14.7029C1.28185 14.4604 1.45293 14.1649 1.79508 13.5739Z"
        fill="#FF424E"
        stroke="#FF424E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="8.875"
        y1="6.625"
        x2="8.875"
        y2="9.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="9" cy="12.375" r="1.125" fill="white"/>
    </svg>
  ),
  caretRight: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76644 8.51719L10.5164 4.76719C10.5673 4.71297 10.6018 4.64545 10.6159 4.57246C10.63 4.49946 10.6231 4.42396 10.5961 4.35469C10.5674 4.28644 10.5192 4.22821 10.4575 4.18733C10.3957 4.14646 10.3233 4.12477 10.2493 4.125L2.74926 4.125C2.67522 4.12477 2.60277 4.14646 2.54105 4.18733C2.47932 4.22821 2.43107 4.28644 2.40238 4.35469C2.38401 4.40094 2.37447 4.45023 2.37426 4.5C2.37468 4.59958 2.41326 4.69521 2.48207 4.76719L6.23207 8.51719C6.30316 8.58761 6.39919 8.62711 6.49925 8.62711C6.59932 8.62711 6.69534 8.58761 6.76644 8.51719Z"
        fill="white"
      />
    </svg>
  ),
  chevronLeft: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.50502 11.505C5.23166 11.7784 5.23166 12.2216 5.50502 12.495C5.77839 12.7683 6.22161 12.7683 6.49497 12.495L5.50502 11.505ZM10 8L10.495 7.50503C10.2216 7.23166 9.77839 7.23166 9.50502 7.50503L10 8ZM13.505 12.495C13.7784 12.7683 14.2216 12.7683 14.495 12.495C14.7683 12.2216 14.7683 11.7784 14.495 11.505L13.505 12.495ZM6.49497 12.495L10.495 8.49497L9.50502 7.50503L5.50502 11.505L6.49497 12.495ZM9.50502 8.49497L13.505 12.495L14.495 11.505L10.495 7.50503L9.50502 8.49497Z"
        fill="#00081D"
      />
    </svg>
  ),
  clock: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00039 4.6399V7.9999L10.2404 9.1199M13.6004 7.9999C13.6004 11.0927 11.0932 13.5999 8.00039 13.5999C4.9076 13.5999 2.40039 11.0927 2.40039 7.9999C2.40039 4.90711 4.9076 2.3999 8.00039 2.3999C11.0932 2.3999 13.6004 4.90711 13.6004 7.9999Z"
        stroke="#7C88A6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clockFastForward: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.025 8.625L15.5254 10.125L14.025 8.625M15.7088 9.75C15.736 9.50375 15.75 9.25351 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C11.1205 15.75 13.0125 14.7722 14.25 13.243M9 5.25V9L11.25 10.5"
        stroke="#7C88A6"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copy03: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6V3.9C6 3.05992 6 2.63988 6.16349 2.31901C6.3073 2.03677 6.53677 1.8073 6.81901 1.66349C7.13988 1.5 7.55992 1.5 8.4 1.5H14.1C14.9401 1.5 15.3601 1.5 15.681 1.66349C15.9632 1.8073 16.1927 2.03677 16.3365 2.31901C16.5 2.63988 16.5 3.05992 16.5 3.9V9.6C16.5 10.4401 16.5 10.8601 16.3365 11.181C16.1927 11.4632 15.9632 11.6927 15.681 11.8365C15.3601 12 14.9401 12 14.1 12H12M3.9 16.5H9.6C10.4401 16.5 10.8601 16.5 11.181 16.3365C11.4632 16.1927 11.6927 15.9632 11.8365 15.681C12 15.3601 12 14.9401 12 14.1V8.4C12 7.55992 12 7.13988 11.8365 6.81901C11.6927 6.53677 11.4632 6.3073 11.181 6.16349C10.8601 6 10.4401 6 9.6 6H3.9C3.05992 6 2.63988 6 2.31901 6.16349C2.03677 6.3073 1.8073 6.53677 1.66349 6.81901C1.5 7.13988 1.5 7.55992 1.5 8.4V14.1C1.5 14.9401 1.5 15.3601 1.66349 15.681C1.8073 15.9632 2.03677 16.1927 2.31901 16.3365C2.63988 16.5 3.05992 16.5 3.9 16.5Z"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copy03_x: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 5.3335V3.46683C5.33398 2.72009 5.33398 2.34672 5.47931 2.06151C5.60714 1.81063 5.81111 1.60665 6.062 1.47882C6.34721 1.3335 6.72058 1.3335 7.46732 1.3335H12.534C13.2807 1.3335 13.6541 1.3335 13.9393 1.47882C14.1902 1.60665 14.3942 1.81063 14.522 2.06151C14.6673 2.34672 14.6673 2.72009 14.6673 3.46683V8.5335C14.6673 9.28023 14.6673 9.6536 14.522 9.93882C14.3942 10.1897 14.1902 10.3937 13.9393 10.5215C13.6541 10.6668 13.2807 10.6668 12.534 10.6668H10.6673M3.46732 14.6668H8.53398C9.28072 14.6668 9.65409 14.6668 9.93931 14.5215C10.1902 14.3937 10.3942 14.1897 10.522 13.9388C10.6673 13.6536 10.6673 13.2802 10.6673 12.5335V7.46683C10.6673 6.72009 10.6673 6.34672 10.522 6.06151C10.3942 5.81063 10.1902 5.60665 9.93931 5.47882C9.65409 5.3335 9.28072 5.3335 8.53398 5.3335H3.46732C2.72058 5.3335 2.34721 5.3335 2.062 5.47882C1.81111 5.60665 1.60714 5.81063 1.47931 6.06151C1.33398 6.34672 1.33398 6.72009 1.33398 7.46683V12.5335C1.33398 13.2802 1.33398 13.6536 1.47931 13.9388C1.60714 14.1897 1.81111 14.3937 2.062 14.5215C2.34721 14.6668 2.72058 14.6668 3.46732 14.6668Z"
        stroke="#1A94FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copy04_x: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.96763 15.1116C2.65987 15.1116 2.39301 14.9987 2.16706 14.7727C1.9411 14.5468 1.82813 14.2799 1.82812 13.9721V3.95801H2.96763V13.9721H10.8318V15.1116H2.96763ZM5.10314 12.9721C4.79649 12.9721 4.53057 12.8596 4.30539 12.6344C4.08021 12.4092 3.96763 12.1433 3.96763 11.8366V2.57505C3.96763 2.26729 4.08021 2.00044 4.30539 1.77448C4.53057 1.54852 4.79649 1.43555 5.10314 1.43555H12.3647C12.6725 1.43555 12.9393 1.54852 13.1653 1.77448C13.3912 2.00044 13.5042 2.26729 13.5042 2.57505V11.8366C13.5042 12.1433 13.3912 12.4092 13.1653 12.6344C12.9393 12.8596 12.6725 12.9721 12.3647 12.9721H5.10314ZM5.10314 11.8366H12.3647V2.57505H5.10314V11.8366Z" fill="#3264FF"/>
    </svg>
  ),
  danger: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17C6.1339 17 3 13.8661 3 10C3 6.1339 6.1339 3 10 3C13.8661 3 17 6.1339 17 10C17 13.8661 13.8661 17 10 17Z"
        fill="#EE4064"
      />
      <path
        d="M10 7V11M10 13.6667H10.0083"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  share: (
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.357 13.6197C14.7208 13.6197 14.1338 13.8429 13.6739 14.2156L9.04893 10.8697C9.12638 10.4446 9.12638 10.009 9.04893 9.58395L13.6739 6.23797C14.1338 6.61074 14.7208 6.83395 15.357 6.83395C16.8346 6.83395 18.0355 5.63306 18.0355 4.15538C18.0355 2.6777 16.8346 1.47681 15.357 1.47681C13.8793 1.47681 12.6784 2.6777 12.6784 4.15538C12.6784 4.41431 12.7141 4.66207 12.7833 4.89868L8.39045 8.07949C7.73867 7.21565 6.70295 6.65538 5.53554 6.65538C3.56233 6.65538 1.96411 8.25359 1.96411 10.2268C1.96411 12.2 3.56233 13.7982 5.53554 13.7982C6.70295 13.7982 7.73867 13.238 8.39045 12.3741L12.7833 15.5549C12.7141 15.7915 12.6784 16.0415 12.6784 16.2982C12.6784 17.7759 13.8793 18.9768 15.357 18.9768C16.8346 18.9768 18.0355 17.7759 18.0355 16.2982C18.0355 14.8206 16.8346 13.6197 15.357 13.6197ZM15.357 2.99466C15.9976 2.99466 16.5177 3.51475 16.5177 4.15538C16.5177 4.796 15.9976 5.31609 15.357 5.31609C14.7163 5.31609 14.1963 4.796 14.1963 4.15538C14.1963 3.51475 14.7163 2.99466 15.357 2.99466ZM5.53554 12.1911C4.45295 12.1911 3.57125 11.3094 3.57125 10.2268C3.57125 9.14422 4.45295 8.26252 5.53554 8.26252C6.61813 8.26252 7.49983 9.14422 7.49983 10.2268C7.49983 11.3094 6.61813 12.1911 5.53554 12.1911ZM15.357 17.459C14.7163 17.459 14.1963 16.9389 14.1963 16.2982C14.1963 15.6576 14.7163 15.1375 15.357 15.1375C15.9976 15.1375 16.5177 15.6576 16.5177 16.2982C16.5177 16.9389 15.9976 17.459 15.357 17.459Z" fill="#3264FF"/>
      </svg>
  ),
  export: (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9.5V10.3C13 11.4201 13 11.9802 12.782 12.408C12.5903 12.7843 12.2843 13.0903 11.908 13.282C11.4802 13.5 10.9201 13.5 9.8 13.5H4.2C3.07989 13.5 2.51984 13.5 2.09202 13.282C1.71569 13.0903 1.40973 12.7843 1.21799 12.408C1 11.9802 1 11.4201 1 10.3V9.5M10.3333 6.16667L7 9.5M7 9.5L3.66667 6.16667M7 9.5V1.5"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filePlus: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6668 8.74984V5.6665C16.6668 4.26637 16.6668 3.56631 16.3943 3.03153C16.1547 2.56112 15.7722 2.17867 15.3018 1.93899C14.767 1.6665 14.067 1.6665 12.6668 1.6665H7.3335C5.93336 1.6665 5.2333 1.6665 4.69852 1.93899C4.22811 2.17867 3.84566 2.56112 3.60598 3.03153C3.3335 3.56631 3.3335 4.26637 3.3335 5.6665V14.3332C3.3335 15.7333 3.3335 16.4334 3.60598 16.9681C3.84566 17.4386 4.22811 17.821 4.69852 18.0607C5.2333 18.3332 5.93336 18.3332 7.3335 18.3332H10.0002M11.6668 9.1665H6.66683M8.3335 12.4998H6.66683M13.3335 5.83317H6.66683M15.0002 17.4998V12.4998M12.5002 14.9998H17.5002"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filterFunnel02Update: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0226 15.976L11.3668 15.7313L12.0226 15.976ZM11.6364 16.275L11.3764 15.6251L11.6364 16.275ZM11.9143 16.136L12.385 16.6541L11.9143 16.136ZM8.01975 17.3702L8.6032 16.9834L8.01975 17.3702ZM8.8505 17.3894L9.11047 18.0393H9.11047L8.8505 17.3894ZM8.27788 17.5449L8.13546 18.2303L8.27788 17.5449ZM7.93197 10.9192L8.61526 10.7672L7.93197 10.9192ZM7.61754 10.4109L7.09588 10.8776L7.61754 10.4109ZM7.84689 10.6965L8.4575 10.3543L7.84689 10.6965ZM12.068 10.9192L11.3847 10.7672L12.068 10.9192ZM12.3825 10.4109L11.8608 9.94412L12.3825 10.4109ZM12.1531 10.6965L11.5425 10.3543L12.1531 10.6965ZM17.7023 3.18755L18.148 2.64777L17.7023 3.18755ZM17.0581 5.1852L17.5797 5.65195L17.0581 5.1852ZM17.9994 3.8519L18.6988 3.87968L17.9994 3.8519ZM2.29769 3.18755L1.852 2.64777H1.852L2.29769 3.18755ZM2.94194 5.18519L3.46361 4.71844L2.94194 5.18519ZM2.00065 3.8519L1.3012 3.87968L2.00065 3.8519ZM3.91896 3.7H16.081V2.3H3.91896V3.7ZM8.65154 16.7807V11.2851H7.25154V16.7807H8.65154ZM11.3485 11.2851V15.6664H12.7485V11.2851H11.3485ZM11.3764 15.6251L8.59052 16.7394L9.11047 18.0393L11.8964 16.9249L11.3764 15.6251ZM8.13921 9.94412L3.46361 4.71844L2.42027 5.65195L7.09588 10.8776L8.13921 9.94412ZM16.5364 4.71844L11.8608 9.94412L12.9041 10.8776L17.5797 5.65195L16.5364 4.71844ZM11.3485 15.6664C11.3485 15.7077 11.3485 15.7379 11.3481 15.7635C11.3478 15.7891 11.3472 15.8024 11.3468 15.809C11.346 15.8207 11.3471 15.784 11.3668 15.7313L12.6785 16.2207C12.7591 16.0046 12.7485 15.7707 12.7485 15.6664H11.3485ZM11.8964 16.9249C11.9933 16.8862 12.2143 16.8092 12.385 16.6541L11.4435 15.6179C11.4851 15.5801 11.5188 15.5654 11.5082 15.5705C11.5022 15.5734 11.4901 15.5789 11.4665 15.5886C11.4428 15.5985 11.4148 15.6097 11.3764 15.6251L11.8964 16.9249ZM11.3668 15.7313C11.383 15.6879 11.4093 15.6491 11.4435 15.6179L12.385 16.6541C12.516 16.5351 12.6166 16.3865 12.6785 16.2207L11.3668 15.7313ZM7.25154 16.7807C7.25154 16.9295 7.25085 17.0887 7.26293 17.2218C7.27518 17.3567 7.30658 17.5612 7.43631 17.7569L8.6032 16.9834C8.66471 17.0762 8.662 17.1482 8.6572 17.0952C8.65519 17.0731 8.65345 17.0387 8.6525 16.9832C8.65156 16.928 8.65154 16.8636 8.65154 16.7807H7.25154ZM8.59052 16.7394C8.5136 16.7702 8.45375 16.7941 8.40213 16.8137C8.35026 16.8335 8.31769 16.8446 8.29642 16.851C8.24546 16.8662 8.31129 16.8369 8.42029 16.8596L8.13546 18.2303C8.36534 18.2781 8.5669 18.2313 8.69674 18.1925C8.82476 18.1543 8.97233 18.0945 9.11047 18.0393L8.59052 16.7394ZM7.43631 17.7569C7.59788 18.0007 7.84914 18.1708 8.13546 18.2303L8.42029 16.8596C8.4952 16.8751 8.56093 16.9196 8.6032 16.9834L7.43631 17.7569ZM8.65154 11.2851C8.65154 11.1304 8.65541 10.9476 8.61526 10.7672L7.24869 11.0713C7.2465 11.0615 7.24832 11.0625 7.24973 11.0955C7.25139 11.1345 7.25154 11.1867 7.25154 11.2851H8.65154ZM7.09588 10.8776C7.16143 10.9509 7.19618 10.99 7.22093 11.0201C7.24186 11.0456 7.24122 11.0476 7.23629 11.0388L8.4575 10.3543C8.36711 10.193 8.24232 10.0594 8.13921 9.94412L7.09588 10.8776ZM8.61526 10.7672C8.58308 10.6226 8.52993 10.4835 8.4575 10.3543L7.23629 11.0388C7.24198 11.049 7.24616 11.0599 7.24869 11.0713L8.61526 10.7672ZM12.7485 11.2851C12.7485 11.1867 12.7486 11.1345 12.7503 11.0955C12.7517 11.0625 12.7535 11.0615 12.7513 11.0713L11.3847 10.7672C11.3446 10.9476 11.3485 11.1304 11.3485 11.2851H12.7485ZM11.8608 9.94412C11.7577 10.0594 11.6329 10.193 11.5425 10.3543L12.7637 11.0388C12.7588 11.0476 12.7581 11.0456 12.7791 11.0201C12.8038 10.99 12.8386 10.9509 12.9041 10.8776L11.8608 9.94412ZM12.7513 11.0713C12.7538 11.0599 12.758 11.049 12.7637 11.0388L11.5425 10.3543C11.4701 10.4835 11.4169 10.6226 11.3847 10.7672L12.7513 11.0713ZM16.081 3.7C16.5597 3.7 16.8705 3.70068 17.0924 3.72063C17.3317 3.74215 17.3175 3.77757 17.2566 3.72733L18.148 2.64777C17.86 2.40998 17.4998 2.35162 17.2177 2.32626C16.9181 2.29932 16.5318 2.3 16.081 2.3V3.7ZM17.5797 5.65195C17.8803 5.31601 18.1384 5.02861 18.3181 4.78735C18.4873 4.56019 18.684 4.25285 18.6988 3.87968L17.2999 3.82412C17.303 3.74527 17.3389 3.75826 17.1954 3.95101C17.0623 4.12965 16.8556 4.36173 16.5364 4.71844L17.5797 5.65195ZM17.2566 3.72733C17.2854 3.75106 17.3014 3.78687 17.2999 3.82412L18.6988 3.87968C18.7176 3.40556 18.5139 2.94987 18.148 2.64777L17.2566 3.72733ZM3.91896 2.3C3.46818 2.3 3.08192 2.29932 2.78228 2.32626C2.50017 2.35162 2.13999 2.40998 1.852 2.64777L2.74337 3.72733C2.68252 3.77757 2.66826 3.74215 2.90765 3.72063C3.12951 3.70068 3.44032 3.7 3.91896 3.7V2.3ZM3.46361 4.71844C3.14445 4.36173 2.93772 4.12965 2.80464 3.95101C2.66106 3.75826 2.69696 3.74527 2.7001 3.82412L1.3012 3.87968C1.31602 4.25285 1.5127 4.56019 1.6819 4.78735C1.86162 5.02861 2.11969 5.31601 2.42027 5.65195L3.46361 4.71844ZM1.852 2.64777C1.48611 2.94987 1.28237 3.40556 1.3012 3.87968L2.7001 3.82412C2.69862 3.78687 2.71463 3.75106 2.74337 3.72733L1.852 2.64777Z"
        fill="#3264FF"
      />
    </svg>
  ),
  filterFunnel02: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0226 15.976L11.3668 15.7313L12.0226 15.976ZM11.6364 16.275L11.3764 15.6251L11.6364 16.275ZM11.9143 16.136L12.385 16.6541L11.9143 16.136ZM8.01975 17.3702L8.6032 16.9834L8.01975 17.3702ZM8.8505 17.3894L9.11047 18.0393H9.11047L8.8505 17.3894ZM8.27788 17.5449L8.13546 18.2303L8.27788 17.5449ZM7.93197 10.9192L8.61526 10.7672L7.93197 10.9192ZM7.61754 10.4109L7.09588 10.8776L7.61754 10.4109ZM7.84689 10.6965L8.4575 10.3543L7.84689 10.6965ZM12.068 10.9192L11.3847 10.7672L12.068 10.9192ZM12.3825 10.4109L11.8608 9.94412L12.3825 10.4109ZM12.1531 10.6965L11.5425 10.3543L12.1531 10.6965ZM17.7023 3.18755L18.148 2.64777L17.7023 3.18755ZM17.0581 5.1852L17.5797 5.65195L17.0581 5.1852ZM17.9994 3.8519L18.6988 3.87968L17.9994 3.8519ZM2.29769 3.18755L1.852 2.64777H1.852L2.29769 3.18755ZM2.94194 5.18519L3.46361 4.71844L2.94194 5.18519ZM2.00065 3.8519L1.3012 3.87968L2.00065 3.8519ZM3.91896 3.7H16.081V2.3H3.91896V3.7ZM8.65154 16.7807V11.2851H7.25154V16.7807H8.65154ZM11.3485 11.2851V15.6664H12.7485V11.2851H11.3485ZM11.3764 15.6251L8.59052 16.7394L9.11047 18.0393L11.8964 16.9249L11.3764 15.6251ZM8.13921 9.94412L3.46361 4.71844L2.42027 5.65195L7.09588 10.8776L8.13921 9.94412ZM16.5364 4.71844L11.8608 9.94412L12.9041 10.8776L17.5797 5.65195L16.5364 4.71844ZM11.3485 15.6664C11.3485 15.7077 11.3485 15.7379 11.3481 15.7635C11.3478 15.7891 11.3472 15.8024 11.3468 15.809C11.346 15.8207 11.3471 15.784 11.3668 15.7313L12.6785 16.2207C12.7591 16.0046 12.7485 15.7707 12.7485 15.6664H11.3485ZM11.8964 16.9249C11.9933 16.8862 12.2143 16.8092 12.385 16.6541L11.4435 15.6179C11.4851 15.5801 11.5188 15.5654 11.5082 15.5705C11.5022 15.5734 11.4901 15.5789 11.4665 15.5886C11.4428 15.5985 11.4148 15.6097 11.3764 15.6251L11.8964 16.9249ZM11.3668 15.7313C11.383 15.6879 11.4093 15.6491 11.4435 15.6179L12.385 16.6541C12.516 16.5351 12.6166 16.3865 12.6785 16.2207L11.3668 15.7313ZM7.25154 16.7807C7.25154 16.9295 7.25085 17.0887 7.26293 17.2218C7.27518 17.3567 7.30658 17.5612 7.43631 17.7569L8.6032 16.9834C8.66471 17.0762 8.662 17.1482 8.6572 17.0952C8.65519 17.0731 8.65345 17.0387 8.6525 16.9832C8.65156 16.928 8.65154 16.8636 8.65154 16.7807H7.25154ZM8.59052 16.7394C8.5136 16.7702 8.45375 16.7941 8.40213 16.8137C8.35026 16.8335 8.31769 16.8446 8.29642 16.851C8.24546 16.8662 8.31129 16.8369 8.42029 16.8596L8.13546 18.2303C8.36534 18.2781 8.5669 18.2313 8.69674 18.1925C8.82476 18.1543 8.97233 18.0945 9.11047 18.0393L8.59052 16.7394ZM7.43631 17.7569C7.59788 18.0007 7.84914 18.1708 8.13546 18.2303L8.42029 16.8596C8.4952 16.8751 8.56093 16.9196 8.6032 16.9834L7.43631 17.7569ZM8.65154 11.2851C8.65154 11.1304 8.65541 10.9476 8.61526 10.7672L7.24869 11.0713C7.2465 11.0615 7.24832 11.0625 7.24973 11.0955C7.25139 11.1345 7.25154 11.1867 7.25154 11.2851H8.65154ZM7.09588 10.8776C7.16143 10.9509 7.19618 10.99 7.22093 11.0201C7.24186 11.0456 7.24122 11.0476 7.23629 11.0388L8.4575 10.3543C8.36711 10.193 8.24232 10.0594 8.13921 9.94412L7.09588 10.8776ZM8.61526 10.7672C8.58308 10.6226 8.52993 10.4835 8.4575 10.3543L7.23629 11.0388C7.24198 11.049 7.24616 11.0599 7.24869 11.0713L8.61526 10.7672ZM12.7485 11.2851C12.7485 11.1867 12.7486 11.1345 12.7503 11.0955C12.7517 11.0625 12.7535 11.0615 12.7513 11.0713L11.3847 10.7672C11.3446 10.9476 11.3485 11.1304 11.3485 11.2851H12.7485ZM11.8608 9.94412C11.7577 10.0594 11.6329 10.193 11.5425 10.3543L12.7637 11.0388C12.7588 11.0476 12.7581 11.0456 12.7791 11.0201C12.8038 10.99 12.8386 10.9509 12.9041 10.8776L11.8608 9.94412ZM12.7513 11.0713C12.7538 11.0599 12.758 11.049 12.7637 11.0388L11.5425 10.3543C11.4701 10.4835 11.4169 10.6226 11.3847 10.7672L12.7513 11.0713ZM16.081 3.7C16.5597 3.7 16.8705 3.70068 17.0924 3.72063C17.3317 3.74215 17.3175 3.77757 17.2566 3.72733L18.148 2.64777C17.86 2.40998 17.4998 2.35162 17.2177 2.32626C16.9181 2.29932 16.5318 2.3 16.081 2.3V3.7ZM17.5797 5.65195C17.8803 5.31601 18.1384 5.02861 18.3181 4.78735C18.4873 4.56019 18.684 4.25285 18.6988 3.87968L17.2999 3.82412C17.303 3.74527 17.3389 3.75826 17.1954 3.95101C17.0623 4.12965 16.8556 4.36173 16.5364 4.71844L17.5797 5.65195ZM17.2566 3.72733C17.2854 3.75106 17.3014 3.78687 17.2999 3.82412L18.6988 3.87968C18.7176 3.40556 18.5139 2.94987 18.148 2.64777L17.2566 3.72733ZM3.91896 2.3C3.46818 2.3 3.08192 2.29932 2.78228 2.32626C2.50017 2.35162 2.13999 2.40998 1.852 2.64777L2.74337 3.72733C2.68252 3.77757 2.66826 3.74215 2.90765 3.72063C3.12951 3.70068 3.44032 3.7 3.91896 3.7V2.3ZM3.46361 4.71844C3.14445 4.36173 2.93772 4.12965 2.80464 3.95101C2.66106 3.75826 2.69696 3.74527 2.7001 3.82412L1.3012 3.87968C1.31602 4.25285 1.5127 4.56019 1.6819 4.78735C1.86162 5.02861 2.11969 5.31601 2.42027 5.65195L3.46361 4.71844ZM1.852 2.64777C1.48611 2.94987 1.28237 3.40556 1.3012 3.87968L2.7001 3.82412C2.69862 3.78687 2.71463 3.75106 2.74337 3.72733L1.852 2.64777Z"
        fill="#3264FF"
      />
    </svg>
  ),
  filterFunnel02_solid: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35316 4.14806C1.85737 3.59394 1.60948 3.31688 1.60013 3.08142C1.592 2.87687 1.6799 2.68028 1.83776 2.54994C2.01947 2.3999 2.39124 2.3999 3.13478 2.3999H12.8644C13.608 2.3999 13.9798 2.3999 14.1615 2.54994C14.3193 2.68028 14.4072 2.87687 14.3991 3.08142C14.3897 3.31688 14.1418 3.59394 13.6461 4.14806L9.90557 8.3286C9.80674 8.43906 9.75733 8.49429 9.7221 8.55714C9.69085 8.61289 9.66792 8.6729 9.65403 8.73528C9.63838 8.80562 9.63838 8.87973 9.63838 9.02794V12.533C9.63838 12.6612 9.63838 12.7253 9.61771 12.7807C9.59944 12.8297 9.56972 12.8736 9.53104 12.9087C9.48727 12.9485 9.42776 12.9723 9.30873 13.0199L7.08001 13.9114C6.83908 14.0078 6.71861 14.0559 6.62191 14.0358C6.53735 14.0183 6.46313 13.968 6.41541 13.896C6.36084 13.8137 6.36084 13.684 6.36084 13.4245V9.02794C6.36084 8.87973 6.36084 8.80562 6.34519 8.73528C6.3313 8.6729 6.30837 8.61289 6.27712 8.55714C6.24189 8.49429 6.19247 8.43906 6.09364 8.3286L2.35316 4.14806Z"
        fill="#3264FF"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag03: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.75H14.6903C15.0371 9.75 15.2106 9.75 15.3096 9.67726C15.396 9.61384 15.4511 9.5165 15.4611 9.4098C15.4725 9.28745 15.3832 9.13872 15.2048 8.8413L13.6852 6.3087C13.6179 6.19646 13.5842 6.14034 13.571 6.08043C13.5594 6.02744 13.5594 5.97256 13.571 5.91957C13.5842 5.85966 13.6179 5.80354 13.6852 5.6913L15.2048 3.1587C15.3832 2.86127 15.4725 2.71256 15.4611 2.5902C15.4511 2.4835 15.396 2.38616 15.3096 2.32273C15.2106 2.25 15.0371 2.25 14.6903 2.25H3L3 15.75"
        stroke="#FF424E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gearSix: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8179 9.95213C19.8002 9.87229 19.7655 9.79718 19.7162 9.7319C19.667 9.66662 19.6043 9.61268 19.5323 9.57373L17.8331 8.63129C17.7427 8.44566 17.6427 8.26717 17.5332 8.09582L17.5618 6.15383C17.5624 6.07238 17.5463 5.99167 17.5144 5.91673C17.4824 5.8418 17.4354 5.77425 17.3762 5.71831C16.5301 4.95121 15.5295 4.37423 14.4418 4.02622C14.3636 4.00186 14.2813 3.99436 14.2 4.0042C14.1188 4.01405 14.0406 4.04102 13.9705 4.08333L12.307 5.08289C12.1 5.07575 11.9 5.07575 11.693 5.08289L10.0295 4.08333C9.95942 4.04102 9.88121 4.01405 9.79998 4.0042C9.71875 3.99436 9.63635 4.00186 9.55824 4.02622C8.46906 4.37449 7.46806 4.95415 6.62384 5.72545C6.56411 5.77947 6.51664 5.84565 6.48462 5.91954C6.4526 5.99343 6.43678 6.07332 6.43821 6.15383L6.47391 8.09582C6.35967 8.26717 6.25972 8.44566 6.15976 8.63129L4.46766 9.57373C4.39485 9.6115 4.3314 9.66509 4.28199 9.73056C4.23257 9.79604 4.19843 9.87175 4.18208 9.95213C3.93931 11.0671 3.93931 12.2213 4.18208 13.3363C4.19981 13.4162 4.23449 13.4913 4.28376 13.5566C4.33303 13.6218 4.39574 13.6758 4.46766 13.7147L6.1669 14.6572C6.25799 14.8419 6.36053 15.0207 6.47391 15.1926L6.43821 17.1346C6.43756 17.2161 6.4537 17.2968 6.48564 17.3717C6.51758 17.4467 6.56463 17.5142 6.62384 17.5701C7.47108 18.3356 8.4713 18.9124 9.55824 19.2622C9.63635 19.2866 9.71875 19.2941 9.79998 19.2843C9.88121 19.2744 9.95942 19.2474 10.0295 19.2051L11.693 18.2056H12.307L13.9777 19.2051C14.0645 19.2622 14.1665 19.2921 14.2704 19.2908C14.3285 19.2883 14.386 19.2787 14.4418 19.2622C15.5309 18.914 16.5319 18.3343 17.3762 17.563C17.4359 17.509 17.4834 17.4428 17.5154 17.3689C17.5474 17.295 17.5632 17.2151 17.5618 17.1346L17.5332 15.1926C17.6403 15.0213 17.7403 14.8428 17.8402 14.6572L19.5395 13.7147C19.6104 13.6754 19.6719 13.6212 19.72 13.5559C19.768 13.4906 19.8014 13.4157 19.8179 13.3363C20.0607 12.2213 20.0607 11.0671 19.8179 9.95213ZM15.1414 11.6442C15.1414 12.2655 14.9572 12.8729 14.612 13.3895C14.2668 13.9061 13.7762 14.3088 13.2022 14.5465C12.6282 14.7843 11.9965 14.8465 11.3871 14.7253C10.7778 14.6041 10.218 14.3049 9.77866 13.8656C9.33932 13.4262 9.04013 12.8665 8.91891 12.2571C8.7977 11.6477 8.85991 11.0161 9.09768 10.442C9.33545 9.86802 9.7381 9.3774 10.2547 9.03221C10.7713 8.68702 11.3787 8.50278 12 8.50278C12.8332 8.50278 13.6322 8.83375 14.2213 9.42289C14.8105 10.012 15.1414 10.8111 15.1414 11.6442Z"
        fill="#3264FF"
      />
    </svg>
  ),
  inventory: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6666 4.85173L7.99998 7.99987M7.99998 7.99987L2.33331 4.85173M7.99998 7.99987L8 14.3332M9.33333 13.9258L8.51802 14.3788C8.32895 14.4838 8.23442 14.5363 8.1343 14.5569C8.0457 14.5751 7.95431 14.5751 7.8657 14.5569C7.76559 14.5363 7.67105 14.4838 7.48198 14.3788L2.54865 11.638C2.34897 11.5271 2.24912 11.4716 2.17642 11.3927C2.11211 11.3229 2.06343 11.2402 2.03366 11.1501C2 11.0482 2 10.934 2 10.7056V5.29419C2 5.06576 2 4.95155 2.03366 4.84968C2.06343 4.75957 2.11211 4.67684 2.17642 4.60705C2.24912 4.52816 2.34897 4.47269 2.54865 4.36176L7.48198 1.62102C7.67105 1.51598 7.76559 1.46346 7.8657 1.44287C7.95431 1.42464 8.0457 1.42464 8.1343 1.44287C8.23442 1.46346 8.32895 1.51598 8.51802 1.62102L13.4514 4.36176C13.651 4.47269 13.7509 4.52816 13.8236 4.60705C13.8879 4.67684 13.9366 4.75956 13.9663 4.84968C14 4.95155 14 5.06576 14 5.29419L14 8.33323M5 2.99989L11 6.33323M10.6667 11.9999L12 13.3332L14.6667 10.6666"
        stroke="#00AB56"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  inventoryDanger: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6666 4.85173L7.99998 7.99987M7.99998 7.99987L2.33331 4.85173M7.99998 7.99987L8 14.3332M14 8.33323L14 5.29419C14 5.06576 14 4.95155 13.9663 4.84968C13.9366 4.75956 13.8879 4.67684 13.8236 4.60705C13.7509 4.52816 13.651 4.47269 13.4514 4.36176L8.51802 1.62102C8.32895 1.51598 8.23442 1.46346 8.1343 1.44287C8.0457 1.42464 7.95431 1.42464 7.8657 1.44287C7.76559 1.46346 7.67105 1.51598 7.48198 1.62102L2.54865 4.36176C2.34897 4.47269 2.24912 4.52816 2.17642 4.60705C2.11211 4.67684 2.06343 4.75957 2.03366 4.84968C2 4.95155 2 5.06576 2 5.29419V10.7056C2 10.934 2 11.0482 2.03366 11.1501C2.06343 11.2402 2.11211 11.3229 2.17642 11.3927C2.24912 11.4716 2.34897 11.5271 2.54865 11.638L7.48198 14.3788C7.67105 14.4838 7.76559 14.5363 7.8657 14.5569C7.95431 14.5751 8.0457 14.5751 8.1343 14.5569C8.23442 14.5363 8.32895 14.4838 8.51802 14.3788L8.66667 14.2962M5 2.99989L11 6.33323M11 10.6666L14.3333 13.9999M14.3333 10.6666L11 13.9999"
        stroke="#FF424E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  truckCheck: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.875 10.4375H12.375V7.625H15.3692C15.4816 7.625 15.5914 7.65869 15.6845 7.72171C15.7776 7.78474 15.8497 7.87421 15.8914 7.97859L16.875 10.4375Z"
        stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.125 12.125H12.375" stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round"
            stroke-linejoin="round"/>
      <path
        d="M13.2188 17.1875C14.1507 17.1875 14.9062 16.432 14.9062 15.5C14.9062 14.568 14.1507 13.8125 13.2188 13.8125C12.2868 13.8125 11.5312 14.568 11.5312 15.5C11.5312 16.432 12.2868 17.1875 13.2188 17.1875Z"
        stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M4.78125 17.1875C5.71323 17.1875 6.46875 16.432 6.46875 15.5C6.46875 14.568 5.71323 13.8125 4.78125 13.8125C3.84927 13.8125 3.09375 14.568 3.09375 15.5C3.09375 16.432 3.84927 17.1875 4.78125 17.1875Z"
        stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.5312 15.5H6.46875" stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round"
            stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.525391 10.0001V14.9374C0.525391 15.2457 0.647868 15.5414 0.865879 15.7594C1.08389 15.9774 1.37958 16.0999 1.68789 16.0999H3.09414C3.42551 16.0999 3.69414 15.8313 3.69414 15.4999C3.69414 15.1685 3.42551 14.8999 3.09414 14.8999H1.72539V10.0001H0.525391ZM5.99961 7.0999H11.7754V14.0385C11.7754 14.3698 12.044 14.6385 12.3754 14.6385C12.7068 14.6385 12.9754 14.3698 12.9754 14.0385V6.4999C12.9754 6.16853 12.7068 5.8999 12.3754 5.8999H5.99961V7.0999Z"
            fill="#7C88A6"/>
      <path
        d="M12.375 14.0386V10.4375H16.875V14.9375C16.875 15.0867 16.8157 15.2298 16.7102 15.3352C16.6048 15.4407 16.4617 15.5 16.3125 15.5H14.9062"
        stroke="#7C88A6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M8.51858 1.54688H7.81646C7.71802 1.54688 7.62461 1.60212 7.56434 1.69665L3.42293 8.10882L1.4371 5.03348C1.40706 4.98687 1.36877 4.94917 1.32511 4.92323C1.28144 4.89729 1.23353 4.88378 1.18498 4.88371H0.482863C0.415564 4.88371 0.378399 4.97824 0.419582 5.04208L3.17081 9.30212C3.29938 9.50101 3.54648 9.50101 3.67606 9.30212L8.58186 1.70402C8.62304 1.64141 8.58588 1.54688 8.51858 1.54688Z"
        fill="#7C88A6" fill-opacity="0.85"/>
    </svg>
  ),
  packageX: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.375 5.45825L8.99998 8.99992M8.99998 8.99992L2.62498 5.45825M8.99998 8.99992L9 16.1249M15.75 9.37494L15.75 5.95603C15.75 5.69904 15.75 5.57055 15.7121 5.45595C15.6786 5.35457 15.6239 5.26151 15.5515 5.18299C15.4697 5.09424 15.3574 5.03184 15.1328 4.90704L9.58277 1.8237C9.37007 1.70553 9.26372 1.64645 9.15109 1.62329C9.05141 1.60278 8.9486 1.60278 8.84891 1.62329C8.73629 1.64645 8.62993 1.70554 8.41723 1.8237L2.86723 4.90704C2.64259 5.03184 2.53026 5.09424 2.44847 5.18299C2.37612 5.26151 2.32136 5.35457 2.28786 5.45595C2.25 5.57055 2.25 5.69904 2.25 5.95603V12.0439C2.25 12.3008 2.25 12.4293 2.28786 12.5439C2.32136 12.6453 2.37612 12.7384 2.44847 12.8169C2.53026 12.9056 2.64259 12.968 2.86723 13.0928L8.41723 16.1762C8.62993 16.2943 8.73628 16.3534 8.84891 16.3766C8.9486 16.3971 9.05141 16.3971 9.15109 16.3766C9.26372 16.3534 9.37007 16.2943 9.58277 16.1762L9.75 16.0833M5.625 3.37494L12.375 7.12494M12.375 11.9999L16.125 15.7499M16.125 11.9999L12.375 15.7499"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  resendEmail: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2548_15978)">
        <path
          d="M1.85719 8.86072C1.87504 8.08036 2.03576 7.32322 2.33754 6.61072C2.64647 5.87857 3.08933 5.22321 3.65362 4.65714C4.2179 4.09107 4.87504 3.64821 5.60719 3.33929C6.36433 3.01964 7.1679 2.85714 7.99826 2.85714C8.82862 2.85714 9.63219 3.01964 10.3875 3.33929C11.1176 3.64758 11.7805 4.09521 12.3393 4.65714C12.5161 4.83393 12.6822 5.02143 12.8358 5.21786L11.7608 6.05714C11.7395 6.0736 11.7233 6.09572 11.714 6.12097C11.7048 6.14622 11.7028 6.17356 11.7084 6.19987C11.714 6.22617 11.7269 6.25036 11.7457 6.26965C11.7644 6.28895 11.7882 6.30256 11.8143 6.30893L14.9518 7.07679C15.0411 7.09822 15.1286 7.03036 15.1286 6.93929L15.1429 3.70893C15.1429 3.58929 15.0054 3.52143 14.9125 3.59643L13.9054 4.38393C12.5322 2.62679 10.3965 1.5 7.99647 1.5C3.9054 1.5 0.57683 4.77857 0.500045 8.85357C0.499568 8.87263 0.502911 8.89159 0.509876 8.90934C0.516842 8.92709 0.527289 8.94326 0.540603 8.9569C0.553916 8.97055 0.569826 8.98139 0.587395 8.9888C0.604964 8.9962 0.623837 9.00001 0.642902 9H1.71433C1.7929 9 1.8554 8.9375 1.85719 8.86072ZM15.3572 9H14.2858C14.2072 9 14.1447 9.0625 14.1429 9.13929C14.125 9.91964 13.9643 10.6768 13.6625 11.3893C13.3536 12.1214 12.9108 12.7786 12.3465 13.3429C11.7769 13.9148 11.0998 14.3683 10.3541 14.6772C9.60843 14.9861 8.80897 15.1444 8.00183 15.1429C7.19496 15.1444 6.39578 14.9861 5.6504 14.6771C4.90502 14.3682 4.22819 13.9147 3.65897 13.3429C3.48219 13.1661 3.31612 12.9786 3.16254 12.7821L4.23754 11.9429C4.25881 11.9264 4.27501 11.9043 4.28426 11.879C4.29352 11.8538 4.29546 11.8264 4.28986 11.8001C4.28427 11.7738 4.27136 11.7496 4.25263 11.7304C4.2339 11.7111 4.2101 11.6974 4.18397 11.6911L1.04647 10.9232C0.957188 10.9018 0.869687 10.9696 0.869687 11.0607L0.857188 14.2929C0.857188 14.4125 0.994688 14.4804 1.08754 14.4054L2.09469 13.6179C3.4679 15.3732 5.60362 16.5 8.00362 16.5C12.0965 16.5 15.4233 13.2196 15.5 9.14643C15.5005 9.12737 15.4972 9.10841 15.4902 9.09066C15.4832 9.07292 15.4728 9.05674 15.4595 9.0431C15.4462 9.02945 15.4303 9.01861 15.4127 9.01121C15.3951 9.00381 15.3763 9 15.3572 9Z"
          fill="#7C88A6"/>
      </g>
      <g clip-path="url(#clip1_2548_15978)">
        <path
          d="M10.7857 6.64258H5.21429C5.09576 6.64258 5 6.73834 5 6.85686V11.1426C5 11.2611 5.09576 11.3569 5.21429 11.3569H10.7857C10.9042 11.3569 11 11.2611 11 11.1426V6.85686C11 6.73834 10.9042 6.64258 10.7857 6.64258ZM10.5179 7.38454V10.8747H5.48214V7.38454L5.29732 7.24057L5.56049 6.9024L5.8471 7.12539H10.1536L10.4402 6.9024L10.7033 7.24057L10.5179 7.38454ZM10.1536 7.12472L8 8.79883L5.84643 7.12472L5.55982 6.90173L5.29665 7.2399L5.48147 7.38387L7.76897 9.16244C7.83476 9.21355 7.91569 9.2413 7.999 9.2413C8.0823 9.2413 8.16323 9.21355 8.22902 9.16244L10.5179 7.38454L10.7027 7.24057L10.4395 6.9024L10.1536 7.12472Z"
          fill="#7C88A6"/>
      </g>
      <defs>
        <clipPath id="clip0_2548_15978">
          <rect width="16" height="16" fill="white" transform="translate(0 1)"/>
        </clipPath>
        <clipPath id="clip1_2548_15978">
          <rect width="6" height="6" fill="white" transform="translate(5 6)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  sendKey: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1431 11.62L12.6771 9.62003C12.6941 9.60667 12.708 9.5896 12.7174 9.57011C12.7269 9.55061 12.7319 9.52922 12.7319 9.50753C12.7319 9.48585 12.7269 9.46446 12.7174 9.44496C12.708 9.42547 12.6941 9.4084 12.6771 9.39503L10.1431 7.39503C10.0485 7.32003 9.91099 7.38789 9.91099 7.50753V8.86468H4.12528C4.04671 8.86468 3.98242 8.92896 3.98242 9.00753V10.0075C3.98242 10.0861 4.04671 10.1504 4.12528 10.1504H9.91099V11.5075C9.91099 11.6272 10.0503 11.6932 10.1431 11.62ZM14.8092 4.38789L11.9056 1.48432C11.7717 1.35039 11.6074 1.25218 11.4289 1.1986V1.15039H1.42885C1.11278 1.15039 0.857422 1.40575 0.857422 1.72182V6.68611C0.857422 6.76468 0.921708 6.82896 1.00028 6.82896H2.00028C2.07885 6.82896 2.14314 6.76468 2.14314 6.68611V2.43611H4.57171V4.86468C4.57171 5.18075 4.82707 5.43611 5.14314 5.43611H10.8574C11.1735 5.43611 11.4289 5.18075 11.4289 4.86468V2.82539L13.8574 5.25396V6.68611C13.8574 6.76468 13.9217 6.82896 14.0003 6.82896H15.0003C15.0789 6.82896 15.1431 6.76468 15.1431 6.68611V5.19503C15.1431 4.89146 15.0235 4.60218 14.8092 4.38789ZM10.286 4.29325H5.71457V2.43611H10.286V4.29325ZM15.0003 12.079H14.0003C13.9217 12.079 13.8574 12.1432 13.8574 12.2218V14.1504H2.14314V12.2218C2.14314 12.1432 2.07885 12.079 2.00028 12.079H1.00028C0.921708 12.079 0.857422 12.1432 0.857422 12.2218V14.8647C0.857422 15.1807 1.11278 15.4361 1.42885 15.4361H14.5717C14.8878 15.4361 15.1431 15.1807 15.1431 14.8647V12.2218C15.1431 12.1432 15.0789 12.079 15.0003 12.079Z" fill="#3264FF"/>
    </svg>
  ),
  resendEmailX: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2642_9427)">
        <path d="M1.85719 8.15173C1.87504 7.37137 2.03576 6.61423 2.33754 5.90173C2.64647 5.16959 3.08933 4.51423 3.65362 3.94816C4.2179 3.38209 4.87504 2.93923 5.60719 2.6303C6.36433 2.31066 7.1679 2.14816 7.99826 2.14816C8.82862 2.14816 9.63219 2.31066 10.3875 2.6303C11.1176 2.9386 11.7805 3.38623 12.3393 3.94816C12.5161 4.12494 12.6822 4.31244 12.8358 4.50887L11.7608 5.34816C11.7395 5.36461 11.7233 5.38674 11.714 5.41198C11.7048 5.43723 11.7028 5.46458 11.7084 5.49088C11.714 5.51719 11.7269 5.54137 11.7457 5.56067C11.7644 5.57996 11.7882 5.59358 11.8143 5.59994L14.9518 6.3678C15.0411 6.38923 15.1286 6.32137 15.1286 6.2303L15.1429 2.99994C15.1429 2.8803 15.0054 2.81244 14.9125 2.88744L13.9054 3.67494C12.5322 1.9178 10.3965 0.791016 7.99647 0.791016C3.9054 0.791016 0.57683 4.06959 0.500045 8.14459C0.499568 8.16365 0.502911 8.18261 0.509876 8.20035C0.516842 8.2181 0.527289 8.23427 0.540603 8.24792C0.553916 8.26157 0.569826 8.27241 0.587395 8.27981C0.604964 8.28721 0.623837 8.29102 0.642902 8.29102H1.71433C1.7929 8.29102 1.8554 8.22852 1.85719 8.15173ZM15.3572 8.29102H14.2858C14.2072 8.29102 14.1447 8.35352 14.1429 8.4303C14.125 9.21066 13.9643 9.9678 13.6625 10.6803C13.3536 11.4124 12.9108 12.0696 12.3465 12.6339C11.7769 13.2058 11.0998 13.6593 10.3541 13.9682C9.60843 14.2772 8.80897 14.4354 8.00183 14.4339C7.19496 14.4354 6.39578 14.2771 5.6504 13.9682C4.90502 13.6592 4.22819 13.2057 3.65897 12.6339C3.48219 12.4571 3.31612 12.2696 3.16254 12.0732L4.23754 11.2339C4.25881 11.2174 4.27501 11.1953 4.28426 11.17C4.29352 11.1448 4.29546 11.1175 4.28986 11.0912C4.28427 11.0648 4.27136 11.0407 4.25263 11.0214C4.2339 11.0021 4.2101 10.9885 4.18397 10.9821L1.04647 10.2142C0.957188 10.1928 0.869687 10.2607 0.869687 10.3517L0.857188 13.5839C0.857188 13.7035 0.994688 13.7714 1.08754 13.6964L2.09469 12.9089C3.4679 14.6642 5.60362 15.791 8.00362 15.791C12.0965 15.791 15.4233 12.5107 15.5 8.43745C15.5005 8.41839 15.4972 8.39943 15.4902 8.38168C15.4832 8.36393 15.4728 8.34776 15.4595 8.33411C15.4462 8.32047 15.4303 8.30962 15.4127 8.30222C15.3951 8.29482 15.3763 8.29101 15.3572 8.29102Z" fill="#3264FF"/>
      </g>
      <g clip-path="url(#clip1_2642_9427)">
        <path d="M10.7857 5.93359H5.21429C5.09576 5.93359 5 6.02935 5 6.14788V10.4336C5 10.5521 5.09576 10.6479 5.21429 10.6479H10.7857C10.9042 10.6479 11 10.5521 11 10.4336V6.14788C11 6.02935 10.9042 5.93359 10.7857 5.93359ZM10.5179 6.67556V10.1657H5.48214V6.67556L5.29732 6.53158L5.56049 6.19342L5.8471 6.41641H10.1536L10.4402 6.19342L10.7033 6.53158L10.5179 6.67556ZM10.1536 6.41574L8 8.08984L5.84643 6.41574L5.55982 6.19275L5.29665 6.53092L5.48147 6.67489L7.76897 8.45346C7.83476 8.50457 7.91569 8.53231 7.999 8.53231C8.0823 8.53231 8.16323 8.50457 8.22902 8.45346L10.5179 6.67556L10.7027 6.53158L10.4395 6.19342L10.1536 6.41574Z" fill="#3264FF"/>
      </g>
      <defs>
        <clipPath id="clip0_2642_9427">
          <rect width="16" height="16" fill="white" transform="translate(0 0.291016)"/>
        </clipPath>
        <clipPath id="clip1_2642_9427">
          <rect width="6" height="6" fill="white" transform="translate(5 5.29102)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  printer: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 5.25V3.9C13.5 3.05992 13.5 2.63988 13.3365 2.31901C13.1927 2.03677 12.9632 1.8073 12.681 1.66349C12.3601 1.5 11.9401 1.5 11.1 1.5H6.9C6.05992 1.5 5.63988 1.5 5.31901 1.66349C5.03677 1.8073 4.8073 2.03677 4.66349 2.31901C4.5 2.63988 4.5 3.05992 4.5 3.9V5.25M4.5 13.5C3.80252 13.5 3.45378 13.5 3.16766 13.4233C2.3912 13.2153 1.78472 12.6088 1.57667 11.8323C1.5 11.5462 1.5 11.1975 1.5 10.5V8.85C1.5 7.58988 1.5 6.95982 1.74524 6.47852C1.96095 6.05516 2.30516 5.71095 2.72852 5.49524C3.20982 5.25 3.83988 5.25 5.1 5.25H12.9C14.1601 5.25 14.7902 5.25 15.2715 5.49524C15.6948 5.71095 16.039 6.05516 16.2548 6.47852C16.5 6.95982 16.5 7.58988 16.5 8.85V10.5C16.5 11.1975 16.5 11.5462 16.4233 11.8323C16.2153 12.6088 15.6088 13.2153 14.8323 13.4233C14.5462 13.5 14.1975 13.5 13.5 13.5M11.25 7.875H13.5M6.9 16.5H11.1C11.9401 16.5 12.3601 16.5 12.681 16.3365C12.9632 16.1927 13.1927 15.9632 13.3365 15.681C13.5 15.3601 13.5 14.9401 13.5 14.1V12.9C13.5 12.0599 13.5 11.6399 13.3365 11.319C13.1927 11.0368 12.9632 10.8073 12.681 10.6635C12.3601 10.5 11.9401 10.5 11.1 10.5H6.9C6.05992 10.5 5.63988 10.5 5.31901 10.6635C5.03677 10.8073 4.8073 11.0368 4.66349 11.319C4.5 11.6399 4.5 12.0599 4.5 12.9V14.1C4.5 14.9401 4.5 15.3601 4.66349 15.681C4.8073 15.9632 5.03677 16.1927 5.31901 16.3365C5.63988 16.5 6.05992 16.5 6.9 16.5Z"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  repeat: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58333 17.4165C13.4954 17.4165 16.6667 14.2452 16.6667 10.3332C16.6667 7.97856 15.5178 5.89228 13.75 4.60434M10.4167 18.9998L8.75 17.3332L10.4167 15.6665M9.58333 3.24984C5.67132 3.24984 2.5 6.42115 2.5 10.3332C2.5 12.6878 3.64889 14.7741 5.41667 16.062M8.75 4.99984L10.4167 3.33317L8.75 1.6665"
        stroke="#3264FF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  searchMd: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.505 18.495C17.7784 18.7683 18.2216 18.7683 18.495 18.495C18.7683 18.2216 18.7683 17.7784 18.495 17.505L17.505 18.495ZM14.6283 13.6384C14.3549 13.365 13.9117 13.365 13.6384 13.6384C13.365 13.9117 13.365 14.3549 13.6384 14.6283L14.6283 13.6384ZM18.495 17.505L14.6283 13.6384L13.6384 14.6283L17.505 18.495L18.495 17.505ZM15.5222 9.11111C15.5222 12.6519 12.6519 15.5222 9.11111 15.5222V16.9222C13.4251 16.9222 16.9222 13.4251 16.9222 9.11111H15.5222ZM9.11111 15.5222C5.57035 15.5222 2.7 12.6519 2.7 9.11111H1.3C1.3 13.4251 4.79715 16.9222 9.11111 16.9222V15.5222ZM2.7 9.11111C2.7 5.57035 5.57035 2.7 9.11111 2.7V1.3C4.79715 1.3 1.3 4.79715 1.3 9.11111H2.7ZM9.11111 2.7C12.6519 2.7 15.5222 5.57035 15.5222 9.11111H16.9222C16.9222 4.79715 13.4251 1.3 9.11111 1.3V2.7Z"
        fill="#3264FF"
      />
    </svg>
  ),
  searchMore: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7V1M11 4H17"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9998 1.34983C9.70808 1.31678 9.41148 1.2998 9.11092 1.2998C4.79696 1.2998 1.2998 4.79696 1.2998 9.11092C1.2998 13.4249 4.79696 16.922 9.11092 16.922C11.0159 16.922 12.7615 16.2401 14.1171 15.1071L17.5048 18.4948C17.7782 18.7681 18.2214 18.7681 18.4948 18.4948C18.7681 18.2214 18.7681 17.7782 18.4948 17.5048L15.1071 14.1171C16.2401 12.7615 16.922 11.0159 16.922 9.11092C16.922 8.7337 16.8953 8.36274 16.8436 7.9998H15.4261C15.4891 8.3607 15.522 8.73197 15.522 9.11092C15.522 10.8437 14.8346 12.4158 13.7176 13.5697C13.6899 13.5902 13.6633 13.613 13.6382 13.6382C13.613 13.6633 13.5902 13.6899 13.5697 13.7176C12.4158 14.8346 10.8437 15.522 9.11092 15.522C5.57016 15.522 2.6998 12.6517 2.6998 9.11092C2.6998 5.57016 5.57016 2.6998 9.11092 2.6998C9.41253 2.6998 9.70928 2.72063 9.9998 2.76093V1.34983Z"
        fill="white"
      />
    </svg>
  ),
  truck: (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0352 4.38185H12.3632C12.4503 4.38128 12.5356 4.40707 12.6078 4.45584C12.6799 4.50461 12.7357 4.57407 12.7676 4.65509L13.5327 6.56783"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.29297 7.87939H10.0369"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6905 11.8141C11.4149 11.8141 12.0021 11.2269 12.0021 10.5025C12.0021 9.77814 11.4149 9.19092 10.6905 9.19092C9.96613 9.19092 9.37891 9.77814 9.37891 10.5025C9.37891 11.2269 9.96613 11.8141 10.6905 11.8141Z"
        stroke="#6E6D7A"
        stroke-miterlimit="10"
      />
      <path
        d="M4.13581 11.8141C4.86018 11.8141 5.4474 11.2269 5.4474 10.5025C5.4474 9.77814 4.86018 9.19092 4.13581 9.19092C3.41144 9.19092 2.82422 9.77814 2.82422 10.5025C2.82422 11.2269 3.41144 11.8141 4.13581 11.8141Z"
        stroke="#6E6D7A"
        stroke-miterlimit="10"
      />
      <path
        d="M9.38009 10.5024H5.44531"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.82316 10.5025H1.73017C1.61421 10.5025 1.50301 10.4564 1.42102 10.3744C1.33903 10.2924 1.29297 10.1812 1.29297 10.0653V3.94452C1.29297 3.82857 1.33903 3.71737 1.42102 3.63538C1.50301 3.55339 1.61421 3.50732 1.73017 3.50732H10.0369V9.36577"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0352 6.56787H13.5327V10.0654C13.5327 10.1814 13.4867 10.2926 13.4047 10.3746C13.3227 10.4566 13.2115 10.5026 13.0955 10.5026H12.0025"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  truckX: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 8.4375H12.375V5.625H15.3692C15.4816 5.625 15.5914 5.65869 15.6845 5.72171C15.7776 5.78474 15.8497 5.87421 15.8914 5.97859L16.875 8.4375Z"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.125 10.125H12.375"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2188 15.1875C14.1507 15.1875 14.9062 14.432 14.9062 13.5C14.9062 12.568 14.1507 11.8125 13.2188 11.8125C12.2868 11.8125 11.5312 12.568 11.5312 13.5C11.5312 14.432 12.2868 15.1875 13.2188 15.1875Z"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.78125 15.1875C5.71323 15.1875 6.46875 14.432 6.46875 13.5C6.46875 12.568 5.71323 11.8125 4.78125 11.8125C3.84927 11.8125 3.09375 12.568 3.09375 13.5C3.09375 14.432 3.84927 15.1875 4.78125 15.1875Z"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5312 13.5H6.46875"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.525781 8V12.9373C0.525781 13.2456 0.648258 13.5413 0.86627 13.7593C1.08428 13.9773 1.37997 14.0998 1.68828 14.0998H3.09453C3.4259 14.0998 3.69453 13.8312 3.69453 13.4998C3.69453 13.1684 3.4259 12.8998 3.09453 12.8998H1.72578V8H0.525781ZM6 5.0998H11.7758V12.0384C11.7758 12.3697 12.0444 12.6384 12.3758 12.6384C12.7072 12.6384 12.9758 12.3697 12.9758 12.0384V4.4998C12.9758 4.16843 12.7072 3.8998 12.3758 3.8998H6V5.0998Z"
        fill="#6E6D7A"
      />
      <path
        d="M12.375 12.0386V8.4375H16.875V12.9375C16.875 13.0867 16.8157 13.2298 16.7102 13.3352C16.6048 13.4407 16.4617 13.5 16.3125 13.5H14.9062"
        stroke="#6E6D7A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3L4.125 6.125M4.125 3L1 6.125"
        stroke="#6E6D7A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  confirmOrder: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2548_17614)">
        <path
          d="M12.7566 5.80518H11.8145C11.6095 5.80518 11.4147 5.90361 11.2941 6.07236L8.1361 10.4518L6.70574 8.46701C6.58521 8.30027 6.39235 8.19982 6.18543 8.19982H5.24324C5.11266 8.19982 5.03632 8.34848 5.11266 8.45495L7.61579 11.9264C7.67492 12.0089 7.75288 12.0762 7.84319 12.1226C7.9335 12.169 8.03357 12.1932 8.1351 12.1932C8.23663 12.1932 8.3367 12.169 8.42701 12.1226C8.51732 12.0762 8.59527 12.0089 8.65441 11.9264L12.8852 6.06031C12.9636 5.95384 12.8872 5.80518 12.7566 5.80518Z"
          fill="#7C88A6"/>
        <path
          d="M9 0C4.02991 0 0 4.02991 0 9C0 13.9701 4.02991 18 9 18C13.9701 18 18 13.9701 18 9C18 4.02991 13.9701 0 9 0ZM9 16.4732C4.87366 16.4732 1.52679 13.1263 1.52679 9C1.52679 4.87366 4.87366 1.52679 9 1.52679C13.1263 1.52679 16.4732 4.87366 16.4732 9C16.4732 13.1263 13.1263 16.4732 9 16.4732Z"
          fill="#7C88A6"/>
      </g>
      <defs>
        <clipPath id="clip0_2548_17614">
          <rect width="18" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  lock: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z"
        stroke="#6E6D7A" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  ),
  up: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3791_33920)">
        <path
          d="M10.4496 5.18258L14.8246 9.55381C14.9384 9.67159 15.0014 9.82933 15 9.99306C14.9986 10.1568 14.9328 10.3134 14.8169 10.4292C14.7011 10.545 14.5443 10.6106 14.3804 10.6121C14.2166 10.6135 14.0587 10.5506 13.9408 10.4368L10.0077 6.50707L6.07455 10.4368C6.0169 10.4964 5.94794 10.544 5.87168 10.5767C5.79543 10.6095 5.71342 10.6267 5.63043 10.6274C5.54744 10.6281 5.46514 10.6123 5.38833 10.5809C5.31152 10.5495 5.24174 10.5032 5.18306 10.4445C5.12438 10.3859 5.07797 10.3162 5.04654 10.2394C5.01512 10.1627 4.9993 10.0805 5.00002 9.99755C5.00074 9.91464 5.01799 9.8327 5.05074 9.75651C5.0835 9.68032 5.13111 9.61142 5.1908 9.55381L9.56581 5.18258C9.68301 5.06551 9.84195 4.99975 10.0077 4.99975C10.1734 4.99975 10.3324 5.06551 10.4496 5.18258Z"
          fill="#7C88A6"
        />
        <path
          d="M10.4496 8.30514L14.8246 12.6764C14.9384 12.7941 15.0014 12.9519 15 13.1156C14.9986 13.2793 14.9328 13.436 14.8169 13.5518C14.7011 13.6675 14.5443 13.7332 14.3804 13.7346C14.2166 13.7361 14.0587 13.6731 13.9408 13.5594L10.0077 9.62962L6.07455 13.5594C6.0169 13.619 5.94794 13.6666 5.87168 13.6993C5.79543 13.732 5.71342 13.7493 5.63043 13.75C5.54744 13.7507 5.46514 13.7349 5.38833 13.7035C5.31152 13.6721 5.24174 13.6257 5.18306 13.5671C5.12438 13.5085 5.07797 13.4387 5.04654 13.362C5.01512 13.2853 4.9993 13.203 5.00002 13.1201C5.00074 13.0372 5.01799 12.9553 5.05074 12.8791C5.0835 12.8029 5.13111 12.734 5.1908 12.6764L9.56581 8.30514C9.68301 8.18807 9.84195 8.12231 10.0077 8.12231C10.1734 8.12231 10.3324 8.18807 10.4496 8.30514Z"
          fill="#7C88A6"
        />
      </g>
      <rect
        x="-0.5"
        y="-0.5"
        width="19"
        height="19"
        rx="9.5"
        transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 19 19)"
        stroke="#7C88A6"
      />
      <defs>
        <clipPath id="clip0_3791_33920">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 15 15)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  x: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3334 4.6665L4.66675 11.3332M4.66675 4.6665L11.3334 11.3332"
        stroke="#00081D"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  x2: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.0003"
        cy="10"
        r="8.33333"
        fill="#7C88A6"
        fillOpacity="0.5"
      />
      <path
        d="M12.5003 7.5L7.50033 12.5M7.50033 7.5L12.5003 12.5M18.3337 10C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 10C1.66699 5.39763 5.39795 1.66667 10.0003 1.66667C14.6027 1.66667 18.3337 5.39763 18.3337 10Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  xExcel: (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4.71373L9.05133 0.663649C9.10288 0.612022 9.16409 0.571053 9.23147 0.543082C9.29884 0.51511 9.37107 0.500683 9.44403 0.500625C9.51698 0.500567 9.58923 0.514879 9.65665 0.542744C9.72407 0.570608 9.78535 0.611479 9.83698 0.663024C9.8886 0.714569 9.92957 0.775778 9.95754 0.843156C9.98551 0.910534 9.99994 0.982762 10 1.05572C10.0001 1.12867 9.98575 1.20092 9.95788 1.26834C9.93002 1.33576 9.88914 1.39704 9.8376 1.44867L5.78627 5.5L9.83635 9.55133C9.88798 9.60288 9.92895 9.66409 9.95692 9.73147C9.98489 9.79884 9.99932 9.87107 9.99937 9.94403C9.99943 10.017 9.98512 10.0892 9.95726 10.1567C9.92939 10.2241 9.88852 10.2853 9.83698 10.337C9.78543 10.3886 9.72422 10.4296 9.65684 10.4575C9.58947 10.4855 9.51724 10.4999 9.44428 10.5C9.37133 10.5001 9.29908 10.4857 9.23166 10.4579C9.16424 10.43 9.10296 10.3891 9.05133 10.3376L5 6.28627L0.948665 10.3364C0.89712 10.388 0.835912 10.4289 0.768534 10.4569C0.701156 10.4849 0.628928 10.4993 0.555975 10.4994C0.483021 10.4994 0.41077 10.4851 0.343348 10.4573C0.275925 10.4294 0.214651 10.3885 0.163024 10.337C0.111397 10.2854 0.0704286 10.2242 0.0424569 10.1568C0.0144851 10.0895 5.82122e-05 10.0172 1.75805e-07 9.94428C-5.78606e-05 9.87133 0.0142538 9.79908 0.0421183 9.73166C0.0699828 9.66424 0.110854 9.60296 0.162399 9.55133L4.21373 5.5L0.163649 1.44867C0.0593839 1.34457 0.000742057 1.20331 0.000624845 1.05597C0.000507634 0.908638 0.0589244 0.767289 0.163024 0.663024C0.267124 0.558759 0.408379 0.500117 0.555715 0.5C0.703052 0.499883 0.8444 0.5583 0.948665 0.662399L5 4.71373Z"
        fill="#7C88A6"
      />
    </svg>
  ),
  xlsx: (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0844 3.75569H26.1659V0L0 4.04363V39.4875L26.1659 44V38.4333H42.0844C42.5665 38.4578 43.0387 38.2901 43.3977 37.9669C43.7566 37.6438 43.9732 37.1915 44 36.7089V5.47856C43.9728 4.99626 43.7561 4.54433 43.3971 4.22152C43.0382 3.8987 42.5663 3.73123 42.0844 3.75569ZM42.3359 36.9952H26.1124L26.0857 34.0231H29.9939V30.5616H26.0559L26.037 28.5162H29.9939V25.0547H26.0071L25.9883 23.0093H29.9939V19.5479H25.9757V17.5024H29.9939V14.041H25.9757V11.9956H29.9939V8.5341H25.9757V5.38731H42.3359V36.9952Z"
        fill="#198A73"
      />
      <path
        d="M32.1992 8.51855H38.9925V11.9757H32.1992V8.51855Z"
        fill="#198A73"
      />
      <path
        d="M32.1992 14.0205H38.9925V17.4777H32.1992V14.0205Z"
        fill="#198A73"
      />
      <path
        d="M32.1992 19.522H38.9925V22.9791H32.1992V19.522Z"
        fill="#198A73"
      />
      <path
        d="M32.1992 25.0239H38.9925V28.4811H32.1992V25.0239Z"
        fill="#198A73"
      />
      <path
        d="M32.1992 30.5259H38.9925V33.983H32.1992V30.5259Z"
        fill="#198A73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83602 13.6001L10.2083 13.4069L12.3282 19.2353L14.833 13.1664L18.2053 12.9731L14.1102 21.2483L18.2053 29.5439L14.6397 29.3034L12.2323 22.98L9.8233 29.063L6.54688 28.7739L10.3529 21.4463L6.83602 13.6001Z"
        fill="white"
      />
    </svg>
  ),
  question_blue: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99613 18C14.3809 18 18 14.3791 18 10C18 5.62089 14.3731 2 9.9884 2C5.61141 2 2 5.62089 2 10C2 14.3791 5.61914 18 9.99613 18ZM9.81054 11.5938C9.30788 11.5938 9.02948 11.3617 9.02948 10.8975V10.8124C9.02948 10.0851 9.44708 9.67505 10.0193 9.27273C10.6999 8.80077 11.0324 8.54545 11.0324 8.05029C11.0324 7.51644 10.6225 7.16054 9.9884 7.16054C9.52441 7.16054 9.18415 7.39265 8.92895 7.78723C8.68149 8.06576 8.56549 8.30561 8.1015 8.30561C7.72257 8.30561 7.41324 8.05803 7.41324 7.67118C7.41324 7.51644 7.44418 7.37718 7.49831 7.23791C7.7535 6.47969 8.68149 5.86074 10.0657 5.86074C11.5041 5.86074 12.7182 6.62669 12.7182 7.97292C12.7182 8.90135 12.2078 9.36557 11.4036 9.88395C10.8932 10.2166 10.5993 10.4952 10.5761 10.913C10.5761 10.9362 10.5684 10.9749 10.5684 11.0058C10.5452 11.3385 10.2591 11.5938 9.81054 11.5938ZM9.8028 14.0696C9.27695 14.0696 8.84389 13.6905 8.84389 13.1799C8.84389 12.6692 9.26921 12.2901 9.8028 12.2901C10.3287 12.2901 10.754 12.6692 10.754 13.1799C10.754 13.6983 10.3209 14.0696 9.8028 14.0696Z"
        fill="#1A94FF"
      />
    </svg>
  ),
  close_payment: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 9.37099L13.2411 6.13092C13.2823 6.08962 13.3313 6.05684 13.3852 6.03447C13.4391 6.01209 13.4969 6.00055 13.5552 6.0005C13.6136 6.00045 13.6714 6.0119 13.7253 6.03419C13.7793 6.05649 13.8283 6.08918 13.8696 6.13042C13.9109 6.17166 13.9437 6.22062 13.966 6.27452C13.9884 6.32843 14 6.38621 14 6.44457C14 6.50294 13.9886 6.56074 13.9663 6.61467C13.944 6.66861 13.9113 6.71763 13.8701 6.75893L10.629 10L13.8691 13.2411C13.9104 13.2823 13.9432 13.3313 13.9655 13.3852C13.9879 13.4391 13.9995 13.4969 13.9995 13.5552C13.9995 13.6136 13.9881 13.6714 13.9658 13.7253C13.9435 13.7793 13.9108 13.8283 13.8696 13.8696C13.8283 13.9109 13.7794 13.9437 13.7255 13.966C13.6716 13.9884 13.6138 14 13.5554 14C13.4971 14 13.4393 13.9886 13.3853 13.9663C13.3314 13.944 13.2824 13.9113 13.2411 13.8701L10 10.629L6.75893 13.8691C6.7177 13.9104 6.66873 13.9432 6.61483 13.9655C6.56092 13.9879 6.50314 13.9995 6.44478 13.9995C6.38642 13.9995 6.32862 13.9881 6.27468 13.9658C6.22074 13.9435 6.17172 13.9108 6.13042 13.8696C6.08912 13.8283 6.05634 13.7794 6.03397 13.7255C6.01159 13.6716 6.00005 13.6138 6 13.5554C5.99995 13.4971 6.0114 13.4393 6.03369 13.3853C6.05599 13.3314 6.08868 13.2824 6.12992 13.2411L9.37099 10L6.13092 6.75893C6.04751 6.67565 6.00059 6.56265 6.0005 6.44478C6.00041 6.32691 6.04714 6.21383 6.13042 6.13042C6.2137 6.04701 6.3267 6.00009 6.44457 6C6.56244 5.99991 6.67552 6.04664 6.75893 6.12992L10 9.37099Z"
        fill="#3264FF"/>
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#3264FF"/>
    </svg>
  ),
  dragIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 13.875C10.3284 13.875 11 13.2034 11 12.375C11 11.5466 10.3284 10.875 9.5 10.875C8.67157 10.875 8 11.5466 8 12.375C8 13.2034 8.67157 13.875 9.5 13.875Z"
        fill="#9CA0AB"/>
      <path
        d="M9.5 7.875C10.3284 7.875 11 7.20343 11 6.375C11 5.54657 10.3284 4.875 9.5 4.875C8.67157 4.875 8 5.54657 8 6.375C8 7.20343 8.67157 7.875 9.5 7.875Z"
        fill="#9CA0AB"/>
      <path
        d="M9.5 19.875C10.3284 19.875 11 19.2034 11 18.375C11 17.5466 10.3284 16.875 9.5 16.875C8.67157 16.875 8 17.5466 8 18.375C8 19.2034 8.67157 19.875 9.5 19.875Z"
        fill="#9CA0AB"/>
      <path
        d="M14.8516 13.875C15.68 13.875 16.3516 13.2034 16.3516 12.375C16.3516 11.5466 15.68 10.875 14.8516 10.875C14.0231 10.875 13.3516 11.5466 13.3516 12.375C13.3516 13.2034 14.0231 13.875 14.8516 13.875Z"
        fill="#9CA0AB"/>
      <path
        d="M14.8516 7.875C15.68 7.875 16.3516 7.20343 16.3516 6.375C16.3516 5.54657 15.68 4.875 14.8516 4.875C14.0231 4.875 13.3516 5.54657 13.3516 6.375C13.3516 7.20343 14.0231 7.875 14.8516 7.875Z"
        fill="#9CA0AB"/>
      <path
        d="M14.8516 19.875C15.68 19.875 16.3516 19.2034 16.3516 18.375C16.3516 17.5466 15.68 16.875 14.8516 16.875C14.0231 16.875 13.3516 17.5466 13.3516 18.375C13.3516 19.2034 14.0231 19.875 14.8516 19.875Z"
        fill="#9CA0AB"/>
    </svg>
  ),
  setting: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.8179 9.95213C19.8002 9.87229 19.7655 9.79718 19.7162 9.7319C19.667 9.66662 19.6043 9.61268 19.5323 9.57373L17.8331 8.63129C17.7427 8.44566 17.6427 8.26717 17.5332 8.09582L17.5618 6.15383C17.5624 6.07238 17.5463 5.99167 17.5144 5.91673C17.4824 5.8418 17.4354 5.77425 17.3762 5.71831C16.5301 4.95121 15.5295 4.37423 14.4418 4.02622C14.3636 4.00186 14.2813 3.99436 14.2 4.0042C14.1188 4.01405 14.0406 4.04102 13.9705 4.08333L12.307 5.08289C12.1 5.07575 11.9 5.07575 11.693 5.08289L10.0295 4.08333C9.95942 4.04102 9.88121 4.01405 9.79998 4.0042C9.71875 3.99436 9.63635 4.00186 9.55824 4.02622C8.46906 4.37449 7.46806 4.95415 6.62384 5.72545C6.56411 5.77947 6.51664 5.84565 6.48462 5.91954C6.4526 5.99343 6.43678 6.07332 6.43821 6.15383L6.47391 8.09582C6.35967 8.26717 6.25972 8.44566 6.15976 8.63129L4.46766 9.57373C4.39485 9.6115 4.3314 9.66509 4.28199 9.73056C4.23257 9.79604 4.19843 9.87175 4.18208 9.95213C3.93931 11.0671 3.93931 12.2213 4.18208 13.3363C4.19981 13.4162 4.23449 13.4913 4.28376 13.5566C4.33303 13.6218 4.39574 13.6758 4.46766 13.7147L6.1669 14.6572C6.25799 14.8419 6.36053 15.0207 6.47391 15.1926L6.43821 17.1346C6.43756 17.2161 6.4537 17.2968 6.48564 17.3717C6.51758 17.4467 6.56463 17.5142 6.62384 17.5701C7.47108 18.3356 8.4713 18.9124 9.55824 19.2622C9.63635 19.2866 9.71875 19.2941 9.79998 19.2843C9.88121 19.2744 9.95942 19.2474 10.0295 19.2051L11.693 18.2056H12.307L13.9777 19.2051C14.0645 19.2622 14.1665 19.2921 14.2704 19.2908C14.3285 19.2883 14.386 19.2787 14.4418 19.2622C15.5309 18.914 16.5319 18.3343 17.3762 17.563C17.4359 17.509 17.4834 17.4428 17.5154 17.3689C17.5474 17.295 17.5632 17.2151 17.5618 17.1346L17.5332 15.1926C17.6403 15.0213 17.7403 14.8428 17.8402 14.6572L19.5395 13.7147C19.6104 13.6754 19.6719 13.6212 19.72 13.5559C19.768 13.4906 19.8014 13.4157 19.8179 13.3363C20.0607 12.2213 20.0607 11.0671 19.8179 9.95213ZM15.1414 11.6442C15.1414 12.2655 14.9572 12.8729 14.612 13.3895C14.2668 13.9061 13.7762 14.3088 13.2022 14.5465C12.6282 14.7843 11.9965 14.8465 11.3871 14.7253C10.7778 14.6041 10.218 14.3049 9.77866 13.8656C9.33932 13.4262 9.04013 12.8665 8.91891 12.2571C8.7977 11.6477 8.85991 11.0161 9.09768 10.442C9.33545 9.86802 9.7381 9.3774 10.2547 9.03221C10.7713 8.68702 11.3787 8.50278 12 8.50278C12.8332 8.50278 13.6322 8.83375 14.2213 9.42289C14.8105 10.012 15.1414 10.8111 15.1414 11.6442Z"
        fill="#3264FF"/>
    </svg>
  ),
  check_success: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#F1FFFC"/>
      <path d="M21.2733 24.5453L31.0886 14.73L33.2698 16.9112L23.4545 26.7264L21.2733 24.5453Z" fill="#3CD6B7"/>
      <path d="M19.0921 31.0888L11.458 23.4547L9.27686 25.6359L16.911 33.27L19.0921 31.0888Z" fill="#3CD6B7"/>
      <path
        d="M23.4545 28.9076L18.0016 23.4547L15.8204 25.6359L23.4545 33.27L38.7227 18.0017L36.5415 15.8206L23.4545 28.9076Z"
        fill="#3CD6B7"/>
    </svg>
  ),
  recycle: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
        stroke="#FF424E" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  ),
  success: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#F1FFFC"/>
      <path
        d="M12.4611 18.1393C11.8753 17.5536 10.9255 17.5536 10.3397 18.1393C9.75394 18.7251 9.75394 19.6749 10.3397 20.2607L12.4611 18.1393ZM16.2004 24L15.1397 25.0607C15.4533 25.3742 15.8895 25.533 16.3312 25.4943C16.773 25.4556 17.175 25.2235 17.4292 24.8602L16.2004 24ZM25.8292 12.8602C26.3043 12.1815 26.1393 11.2462 25.4606 10.7712C24.7819 10.2961 23.8466 10.4611 23.3715 11.1398L25.8292 12.8602ZM10.3397 20.2607L15.1397 25.0607L17.2611 22.9393L12.4611 18.1393L10.3397 20.2607ZM17.4292 24.8602L25.8292 12.8602L23.3715 11.1398L14.9715 23.1398L17.4292 24.8602Z"
        fill="#00E0C2"
      />
    </svg>
  ),
  failed: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#EE4064" fillOpacity="0.1"/>
      <path
        d="M12 12L24 24"
        stroke="#EE4064"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M24 12L12 24"
        stroke="#EE4064"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  ),
  lockCustomer:(
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4663 7.64808H13.252V3.64808C13.252 2.38558 12.2288 1.36237 10.9663 1.36237H6.53774C5.27524 1.36237 4.25202 2.38558 4.25202 3.64808V7.64808H3.03774C2.72167 7.64808 2.46631 7.90344 2.46631 8.21951V15.0767C2.46631 15.3927 2.72167 15.6481 3.03774 15.6481H14.4663C14.7824 15.6481 15.0377 15.3927 15.0377 15.0767V8.21951C15.0377 7.90344 14.7824 7.64808 14.4663 7.64808ZM5.53774 3.64808C5.53774 3.09629 5.98595 2.64808 6.53774 2.64808H10.9663C11.5181 2.64808 11.9663 3.09629 11.9663 3.64808V7.64808H5.53774V3.64808ZM13.752 14.3624H3.75202V8.9338H13.752V14.3624ZM8.25202 11.8802V12.8267C8.25202 12.9052 8.31631 12.9695 8.39488 12.9695H9.10917C9.18774 12.9695 9.25202 12.9052 9.25202 12.8267V11.8802C9.39943 11.7744 9.50945 11.6245 9.56626 11.4522C9.62306 11.2798 9.62372 11.0939 9.56813 10.9212C9.51254 10.7484 9.40358 10.5978 9.25692 10.4909C9.11027 10.3841 8.93349 10.3265 8.75202 10.3265C8.57056 10.3265 8.39378 10.3841 8.24713 10.4909C8.10047 10.5978 7.99151 10.7484 7.93592 10.9212C7.88033 11.0939 7.88099 11.2798 7.93779 11.4522C7.9946 11.6245 8.10462 11.7744 8.25202 11.8802Z" fill="#1890FF"/>
    </svg>

  ),
  unlock:(
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9644 7.64515H5.03578V3.64515C5.03578 3.09336 5.484 2.64515 6.03578 2.64515H10.4644C11.0161 2.64515 11.4644 3.09336 11.4644 3.64515V4.85944C11.4644 4.93801 11.5286 5.00229 11.6072 5.00229H12.6072C12.6858 5.00229 12.7501 4.93801 12.7501 4.85944V3.64515C12.7501 2.38265 11.7269 1.35944 10.4644 1.35944H6.03578C4.77328 1.35944 3.75007 2.38265 3.75007 3.64515V7.64515H2.53578C2.21971 7.64515 1.96436 7.90051 1.96436 8.21658V15.0737C1.96436 15.3898 2.21971 15.6452 2.53578 15.6452H13.9644C14.2804 15.6452 14.5358 15.3898 14.5358 15.0737V8.21658C14.5358 7.90051 14.2804 7.64515 13.9644 7.64515ZM13.2501 14.3594H3.25007V8.93087H13.2501V14.3594ZM7.75007 11.8773V12.8237C7.75007 12.9023 7.81436 12.9666 7.89293 12.9666H8.60721C8.68579 12.9666 8.75007 12.9023 8.75007 12.8237V11.8773C8.89748 11.7715 9.0075 11.6216 9.0643 11.4492C9.12111 11.2769 9.12176 11.091 9.06618 10.9182C9.01059 10.7455 8.90162 10.5949 8.75497 10.488C8.60831 10.3811 8.43153 10.3236 8.25007 10.3236C8.06861 10.3236 7.89183 10.3811 7.74517 10.488C7.59852 10.5949 7.48955 10.7455 7.43397 10.9182C7.37838 11.091 7.37903 11.2769 7.43584 11.4492C7.49264 11.6216 7.60267 11.7715 7.75007 11.8773V11.8773Z" fill="#1677FF" fill-opacity="0.85"/>
    </svg>

  ),
}